const helperObj = {
  setCookie: function (c_name, data, path, exdays, exMinute) {
    if (exdays === void 0) {
      exdays = 365;
    }
    if (exMinute === void 0) {
      exMinute = 0;
    }
    var value = data;
    if (typeof data === "object") {
      value = JSON.stringify(data);
    }
    path = path === undefined ? "" : ";path=" + path;
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    exdate.setMinutes(exdate.getMinutes() + exMinute);
    var c_value =
      decodeURI(value) +
      (exdays == null ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = c_name + "=" + c_value + path;
  },
  getCookie: function (c_name) {
    var cookies = document.cookie.split(";").filter(function (item, value) {
      return item.trim().split("=")[0] == c_name;
    });
    var cookieValues = [];
    if (cookies && cookies.length) {
      cookieValues = cookies.map(function (item, index) {
        var cookieValue = item.trim().split("=")[1];
        if (
          cookieValue.indexOf("{", 0) == 0 &&
          cookieValue.lastIndexOf("}") == cookieValue.length - 1
        ) {
          cookieValue = JSON.parse(cookieValue);
        }
        return cookieValue;
      });
    }
    return cookieValues.length ? cookieValues[0] : "";
  },
};
window.helperObj = helperObj;
const en = {
  DataSubmission: "Data Submission",
  FetchingData: "Fetching Data",
  Home: "Home",
  Boost: "Boost",
  Rejected: "Rejected",
  Completed: "Completed",
  Pending: "Pending",
  Profile: "Profile",
  Record: "Record",
  Remark: "Remark",
  Starting: "Starting",
  Transactions: "Transactions",
  DepositAmount: "Deposit Amount",
  DepositHistory: "Deposit History",
  WithdrawalAmount: "Withdrawal Amount",
  WithdrawalHistory: "Withdrawal History",
  TopWithdrawal: "Top Withdrawal",
  Withdrawal: "Withdrawal",
  Invite: "Invite",
  LuckyDraw: "Lucky Draw",
  BindAccount: "Bind Account",
  BankName: "Bank Name",
  BankAccountName: "Bank Account Name",
  BankAccountNo: "Bank Account No",
  Recharge: "Recharge",
  ProductName: "Product Name",
  ProductNumber: "Product Number",
  OrderHistory: "Order History",
  All: "All",
  BindWallet: "Bind Wallet",
  Logout: "Logout",
  Language: "Language",
  MandatoryWalletAddress: "*Wallet Address",
  Exchange: "Exchange",
  Commission: "Commission",
  CurrentBalance: "Current Balance",
  ContactUs: "Contact Us",
  LoginNameMobileNo: "Username / Mobile No",
  Password: "Password",
  ConfirmPassword: "Confirm Password",
  WithdrawalPassword: "Withdrawal Password",
  ChangePassword: "Change Password",
  NewPassword: "New Password",
  OldPassword: "Old Password",
  ForgotPass: "Forgot Password?",
  SignIn: "Sign In",
  Register: "Register",
  Username: "Username",
  Login: "Login",
  RegisterAgreement: "Register Agreement",
  MobileNo: "Mobile No",
  InvitationCode: "Invitation Code",
  CreditScore: "Credit Score",
  BackToLogin: "Back To Login",
  MembershipLevel: "Membership Level",
  TodaysCommission: "Today's Commission",
  TodaysTotalReset: "Today's Total Reset",
  TotalCommission: "Total Commission",
  TotalAmount: "Total Amount",
  ProcessingAmount: "Processing Amount",
  AccumulatedCommission: "Accumulated Commission",
  LatestEvent: "Latest Event",
  AboutUs: "About Us",
  TNC: "T&C",
  TeamReport: "Team Report",
  Certificate: "Certificate",
  OnlineUsers: "Online Users",
  FromLastMonth: "From Last Month",
  OptimizeDemand: "Optimize Demand",
  OrderCompletion: "Order Completion",
  OrderQuantity: "Order Quantity",
  Confirm: "Confirm",
  Cancel: "Cancel",
  Submit: "Submit",
  Profit: "Profit",
  Value: "Value",
  StartNow: "Start Now",
  AccountBalance: "Account Balance",
  FreezeAmount: "Processing Amount",
  Frozen: "Processing",
  MessageList: "Message List",
  OrderSubmission: "Order Submission",
  CreateTime: "Create Time",
  OrderNumber: "Order Number",
  OrderDetails: "Order Details",
  MyReferralCode: "My Referral Code",
  CopyReferralCode: "Copy Referral Code",
  success: "Success",
  SignInBonus: "Sign In Bonus",
  msg_login_success: "Login Success",
  msg_logout_confirm: "Are you sure you want to log out account?",
  msg_workingtime: "Working time",
  msg_depositwithdrawal:
    "For deposits and withdrawals, please contact our Customer Service",
  msg_clicktocontactus: "Click To Contact Customer Service",
  msg_accountnotexist: "Invalid account or password",
  msg_invalidpassword: "Invalid password",
  msg_grab_order_period:
    "This operation can only be performed during the specified time [START]:00 - [END]:00",
  msg_withdrawalamount_range: "Withdrawal limit is [MINAMT] - [MAXAMT]",
  msg_withdrawalamount_reservedamt: "First withdrawal must reserved [MINAMT]",
  msg_grab_order_disabled:
    "This operation disabled. Please contact customer service.",
  msg_account_disabled: "The account has been disabled",
  msg_account_frozen: "The account transaction function has been frozen",
  msg_account_gap_amount:
    "Your account balance is not enough, there is a gap of [REPLACEVALUE1]. Please contact customer service.",
  msg_order_processing_success: "Order processing completed",
  msg_progress_title:
    "Extracting at full capacity, Estimate need<span style='color: red'> &nbsp;3s&nbsp;</span>Please don't leave the interface!",
  msg_progress_note1: "Synchronizing latest information...",
  msg_progress_note2: "Checking product information...",
  msg_progress_note3: "Matching product orders...",
  msg_progress_note4: "Processing the best product...",
  msg_receive_withdrawal_transfer:
    "You will receive your withdrawal within half an hour",
  msg_insufficient_creditbalance: "Insufficient credit",
  msg_insufficient_creditscore: "Insufficient credit score",
  msg_invalid_password: "Invalid Password",
  msg_input_withdrawalpassword: "Please input withdrawal password",
  msg_please_input_userid: "Please input your username",
  msg_please_input_pass: "Please input login password",
  msg_please_input_mobileno: "Please input your mobile no",
  msg_pass_min_length: "Password length must be at least 8",
  msg_pass_format:
    "Password must contain letters and numbers only with 8 to 50 length",
  msg_pass_confirm: "Please input login password again",
  msg_withpass_min_length: "Withdrawal password length must be at least 8",
  msg_withpass_format:
    "Withdrawal password must contain letters and numbers only with 8 to 50 length",
  msg_please_input_invitecode: "Please input the invitation code",
  msg_balance_insufficient:
    "Unable to start trading due to balance is lower than minimum activation value. Please contact the customer service for further assistance",
  msg_orderset_completed:
    "This round of tasks has been completed, please contact customer service for next steps",
  msg_recharge: "Please contact the customer service for further assistance",
  msg_bank_pass_notice:
    "Dear user, Please do not enter your own bank account password in this box. Our staff will not demand you to provide your bank account password.",
  msg_mandatory_bankname: "Please enter bank name",
  msg_mandatory_bankaccname: "Please enter bank account name",
  msg_mandatory_bankaccno: "Please enter bank account no",
  msg_bank_pass_notice2:
    "Notes: If user need to reset wallet address, please contact our customer service.",
  msg_luckydraw_insufficientdrawcount: "Insufficient draw count",
  msg_username_exist: "Duplicate username",
  msg_mobileno_exist: "Mobile phone number has been registered",
  msg_invalid_invitationcode: "Invalid invitation code",
  msg_inactive_invitationcode: "Invitation code inactive",
  msg_invitation_notallowed: "Your referrer does not have permission to invite",
  msg_mandatory_ordercompletebeforerequest:
    "Complete your orders before submit new request",
  msg_deposit_notice: "Please double confirm our deposit network and address",
  msg_mandatory_bank_receipt: "Mandatory Bank Receipt",
  msg_topup_required: "Please topup for reward",
};
window.en = en;
const ko = {
  Home: "홈",
  Boost: "부스트",
  Rejected: "거부됨",
  Completed: "완료됨",
  Pending: "대기 중",
  Remark: "비고",
  Profile: "윤곽",
  Record: "기록",
  Remark: "주목",
  Starting: "시작",
  Transactions: "업무",
  DepositAmount: "입금액",
  DepositHistory: "입금 내역",
  WithdrawalAmount: "출금 금액",
  WithdrawalHistory: "출금 내역",
  TopWithdrawal: "최고 출금",
  Withdrawal: "철수",
  Invite: "초대하다",
  LuckyDraw: "행운의 추첨",
  BindAccount: "계정 연동",
  BankName: "은행명",
  BankAccountName: "은행 계좌명",
  BankAccountNo: "은행 계좌번호",
  Recharge: "충전",
  ProductName: "상품명",
  ProductNumber: "상품 번호",
  OrderHistory: "주문 내역",
  All: "전체",
  BindWallet: "지갑 연동",
  Logout: "로그아웃",
  Language: "언어",
  MandatoryWalletAddress: "*지갑 주소",
  Exchange: "환전",
  Commission: "수수료",
  CurrentBalance: "현재 잔액",
  ContactUs: "문의하기",
  LoginNameMobileNo: "사용자명 / 휴대폰 번호",
  Password: "비밀번호",
  ConfirmPassword: "비밀번호 확인",
  WithdrawalPassword: "출금 비밀번호",
  ChangePassword: "비밀번호 변경",
  ForgotPass: "비밀번호를 잊으셨나요?",
  SignIn: "로그인",
  Register: "가입하기",
  Username: "사용자명",
  Login: "로그인",
  RegisterAgreement: "가입 약관",
  MobileNo: "휴대폰 번호",
  InvitationCode: "초대 코드",
  CreditScore: "신용 점수",
  BackToLogin: "로그인 화면으로 돌아가기",
  MembershipLevel: "회원 등급",
  TodaysCommission: "오늘의 수수료",
  TodaysTotalReset: "오늘의 전체 재설정",
  TotalCommission: "총 커미션",
  TotalAmount: "총 금액",
  LatestEvent: "최신 이벤트",
  AboutUs: "회사 소개",
  TNC: "이용 약관",
  TeamReport: "팀 보고서",
  Certificate: "증명서",
  OnlineUsers: "온라인 사용자",
  FromLastMonth: "지난달부터",
  OptimizeDemand: "수요 최적화",
  OrderCompletion: "주문 완료",
  OrderQuantity: "주문 수량",
  Confirm: "확인",
  Cancel: "취소",
  Submit: "제출",
  Profit: "이익",
  Value: "가치",
  StartNow: "지금 시작하기",
  AccountBalance: "계좌 잔액",
  FreezeAmount: "처리 중 금액",
  Frozen: "진행 중",
  MessageList: "메시지 목록",
  OrderSubmission: "주문 제출",
  CreateTime: "생성 시간",
  OrderNumber: "주문 번호",
  OrderDetails: "주문 세부 사항",
  MyReferralCode: "내 추천 코드",
  CopyReferralCode: "추천 코드 복사",
  success: "성공",
  msg_login_success: "로그인 성공",
  msg_logout_confirm: "계정을 로그아웃하시겠습니까?",
  msg_workingtime: "근무 시간",
  msg_depositwithdrawal: "입출금을 위해 고객센터에 문의하세요",
  msg_clicktocontactus: "고객센터에 문의하려면 클릭하세요",
  msg_accountnotexist: "계정 또는 비밀번호가 올바르지 않습니다",
  msg_invalidpassword: "잘못된 비밀번호",
  msg_grab_order_period:
    "이 작업은 지정된 시간 [START]:00 - [END]:00에만 수행할 수 있습니다",
  msg_withdrawalamount_range: "출금 한도는 [MINAMT] - [MAXAMT]입니다",
  msg_withdrawalamount_reservedamt: "첫 출금은 예약 필수 [MINAMT]",
  msg_grab_order_disabled:
    "이 작업이 비활성화되었습니다. 고객센터에 문의하세요.",
  msg_account_disabled: "계정이 비활성화되었습니다",
  msg_account_frozen: "계정 거래 기능이 동결되었습니다",
  msg_account_gap_amount:
    "계좌 잔액이 부족합니다. 부족한 금액: [REPLACEVALUE1]. 고객센터에 문의하세요.",
  msg_order_processing_success: "주문 처리가 완료되었습니다",
  msg_progress_title:
    "최대 용량으로 추출 중입니다. 약<span style='color: red'> &nbsp;3초&nbsp;</span> 필요합니다. 인터페이스를 떠나지 마십시오!",
  msg_progress_note1: "최신 정보 동기화 중...",
  msg_progress_note2: "상품 정보 확인 중...",
  msg_progress_note3: "상품 주문 매칭 중...",
  msg_progress_note4: "최상의 상품 처리 중...",
  msg_receive_withdrawal_transfer: "출금은 30분 이내에 처리됩니다",
  msg_insufficient_creditbalance: "잔액 부족",
  msg_insufficient_creditscore: "신용 점수가 부족합니다",
  msg_invalid_password: "잘못된 비밀번호",
  msg_input_withdrawalpassword: "출금 비밀번호를 입력하세요",
  msg_please_input_userid: "사용자 이름을 입력하세요",
  msg_please_input_pass: "로그인 비밀번호를 입력하세요",
  msg_please_input_mobileno: "휴대폰 번호를 입력하세요",
  msg_pass_min_length: "비밀번호는 최소 8자 이상이어야 합니다",
  msg_pass_format:
    "비밀번호는 영문자와 숫자로만 구성되어야 하며 길이는 8~50자여야 합니다",
  msg_pass_confirm: "로그인 비밀번호를 다시 입력하세요",
  msg_withpass_min_length: "출금 비밀번호는 최소 8자 이상이어야 합니다",
  msg_withpass_format:
    "출금 비밀번호는 영문자와 숫자로만 구성되어야 하며 길이는 8~50자여야 합니다",
  msg_please_input_invitecode: "초대 코드를 입력하세요",
  msg_balance_insufficient:
    "최소 활성화 값보다 잔액이 부족하여 거래를 시작할 수 없습니다. 고객센터에 문의하세요",
  msg_recharge: "고객센터에 문의하세요",
  msg_bank_pass_notice:
    "사용자님, 이란에 본인 은행 계좌 비밀번호를 입력하지 마세요. 저희 직원은 계좌 비밀번호를 요구하지 않습니다.",
  msg_mandatory_bankname: "은행 이름을 입력하세요",
  msg_mandatory_bankaccname: "계좌명을 입력하세요",
  msg_mandatory_bankaccno: "계좌번호를 입력하세요",
  msg_bank_pass_notice2:
    "참고: 사용자가 지갑 주소를 재설정하려면 고객센터에 문의하세요.",
  msg_luckydraw_insufficientdrawcount: "추첨 횟수가 부족합니다",
  msg_username_exist: "중복된 사용자 이름입니다",
  msg_mobileno_exist: "휴대폰번호가 등록되었습니다",
  msg_invalid_invitationcode: "잘못된 초대 코드입니다",
  msg_inactive_invitationcode: "초대 코드가 비활성화되었습니다",
  msg_invitation_notallowed: "추천인은 초대 권한이 없습니다",
  msg_mandatory_ordercompletebeforerequest:
    "새 요청을 제출하기 전에 주문을 완료하세요",
};
window.ko = ko;
const es = {
  BankName: "Nombre del banco",
  BankAccountName: "Nombre de la cuenta bancaria",
  BankAccountNo: "Número de cuenta bancaria",
  BindAccount: "Vincular cuenta",
  Transactions: "Actas",
  Home: "Inicio",
  Boost: "Impulsar",
  Rejected: "Rechazado",
  Completed: "Completado",
  Pending: "Pendiente",
  Remark: "Observación",
  DepositAmount: "Monto del depósito",
  DepositHistory: "Historial de depósitos",
  WithdrawalAmount: "Monto de Retiro",
  WithdrawalHistory: "Historial de Retiros",
  TopWithdrawal: "Retiro Superior",
  Recharge: "Recarga",
  Withdrawal: "Retiro",
  Transaction: "Transacción",
  Invite: "Invitar",
  HOME: "INICIO",
  Starting: "Comenzando",
  Record: "Registro",
  Profile: "Perfil",
  ProductName: "Nombre del Producto",
  ProductNumber: "Número de Producto",
  OrderHistory: "Historial de Pedidos",
  All: "Todo",
  BindWallet: "Vincular Billetera",
  Logout: "Cerrar Sesión",
  Language: "idioma",
  MandatoryWalletAddress: "*Dirección de Billetera Obligatoria",
  Exchange: "Nombre del Intercambio",
  Commission: "Comisión",
  CurrentBalance: "Saldo Actual",
  ContactUs: "Contáctanos",
  LoginNameMobileNo: "Nombre de Usuario / Número de Teléfono Móvil",
  Password: "Contraseña",
  ConfirmPassword: "Confirmar Contraseña",
  WithdrawalPassword: "Contraseña de Retiro",
  ChangePassword: "Cambiar Contraseña",
  ForgotPass: "¿Olvidaste tu contraseña?",
  SignIn: "Iniciar Sesión",
  Register: "Registrar",
  Username: "Nombre de Usuario",
  Login: "Iniciar Sesión",
  RegisterAgreement: "Acuerdo de Registro",
  MobileNo: "Número de Teléfono",
  InvitationCode: "Código de Invitación",
  CreditScore: "Puntuación de Crédito",
  BackToLogin: "Volver a Iniciar Sesión",
  MembershipLevel: "Nivel de Membresía",
  TodaysCommission: "Comisión de Hoy",
  TodaysTotalReset: "Restablecimiento total de hoy",
  TotalCommission: "Comisión total",
  TotalAmount: "Cantidad Total",
  LatestEvent: "Último Evento",
  AboutUs: "Acerca de Nosotros",
  TNC: "Términos y Condiciones",
  TeamReport: "Informe de Equipo",
  Certificate: "Certificado",
  OnlineUsers: "Usuarios en Línea",
  FromLastMonth: "Desde el Mes Pasado",
  OrderCompletion: "Finalización de Pedido",
  OptimizeDemand: "Optimizar Demanda",
  OrderQuantity: "Cantidad de Pedido",
  Confirm: "Confirmar",
  Cancel: "Cancelar",
  Submit: "Enviar",
  Profit: "Ganancia",
  Value: "Valor",
  StartNow: "Empieza Ahora",
  AccountBalance: "Saldo de la Cuenta",
  FreezeAmount: "Monto Congelado",
  Frozen: "Tratamiento",
  MessageList: "Lista de Mensajes",
  OrderSubmission: "Envío de Pedido",
  CreateTime: "Hora de Creación",
  OrderNumber: "Número de Pedido",
  OrderDetails: "Detalles del Pedido",
  MyReferralCode: "Mi Código de Referido",
  CopyReferralCode: "Copiar Código de Referido",
  success: "éxito",
  msg_login_success: "Inicio de sesión exitoso",
  msg_logout_confirm: "¿Estás seguro de que deseas cerrar sesión?",
  msg_workingtime: "Horario de trabajo",
  msg_depositwithdrawal:
    "Para consultas sobre depósitos y retiros, comuníquese con nuestro servicio al cliente.",
  msg_clicktocontactus: "Haz clic para contactar con el servicio al cliente.",
  msg_accountnotexist: "Cuenta o contraseña incorrecta.",
  msg_invalidpassword: "Contraseña inválida.",
  msg_grab_order_period:
    "Esta operación solo se puede realizar entre las [START]:00 - [END]:00.",
  msg_withdrawalamount_range:
    "El rango de retiro permitido es de [MINAMT] - [MAXAMT].",
  msg_withdrawalamount_reservedamt: "El primer retiro debe reservarse [MINAMT]",
  msg_grab_order_disabled:
    "Esta operación está deshabilitada. Contacte al servicio al cliente.",
  msg_account_disabled: "La cuenta ha sido deshabilitada.",
  msg_account_frozen: "La función de operaciones de la cuenta está congelada.",
  msg_account_gap_amount:
    "Su saldo es insuficiente, falta [REPLACEVALUE1]. Contacte al servicio al cliente.",
  msg_order_processing_success: "El pedido se procesó con éxito.",
  msg_progress_title:
    "Trabajando a toda capacidad, se estima que tomará<span style='color: red'> &nbsp;3s&nbsp;</span>. ¡Por favor, no abandones la interfaz!",
  msg_progress_note1: "Sincronizando la información más reciente...",
  msg_progress_note2: "Verificando información del producto...",
  msg_progress_note3: "Emparejando pedidos de productos...",
  msg_progress_note4: "Procesando el mejor producto...",
  msg_receive_withdrawal_transfer: "Recibirás los fondos en media hora.",
  msg_insufficient_creditbalance: "Saldo de crédito insuficiente.",
  msg_insufficient_creditscore: "Puntuación de crédito insuficiente.",
  msg_invalid_password: "Contraseña inválida.",
  msg_input_withdrawalpassword: "Por favor, ingrese la contraseña de retiro.",
  msg_please_input_userid: "Por favor, ingrese su nombre de usuario.",
  msg_please_input_pass: "Por favor, ingrese su contraseña.",
  msg_please_input_mobileno: "Por favor, ingrese su número de teléfono móvil.",
  msg_pass_min_length: "La contraseña debe tener al menos 6 caracteres.",
  msg_pass_format:
    "La contraseña debe contener solo letras y números, de 6 a 50 caracteres.",
  msg_pass_confirm: "Por favor, confirme su contraseña.",
  msg_withpass_min_length:
    "La contraseña de retiro debe tener al menos 6 caracteres.",
  msg_withpass_format:
    "La contraseña de retiro debe contener solo letras y números, de 6 a 50 caracteres.",
  msg_please_input_invitecode: "Por favor, ingrese el código de invitación.",
  msg_balance_insufficient:
    "No se puede comenzar el comercio debido a saldo insuficiente. Comuníquese con el servicio al cliente para obtener ayuda.",
  msg_recharge:
    "Por favor, comuníquese con el servicio al cliente para obtener ayuda.",
  msg_bank_pass_notice:
    "Estimado usuario, por favor, no ingrese su contraseña bancaria aquí. Nuestro personal nunca le pedirá la contraseña de su cuenta bancaria.",
  msg_mandatory_bankname: "Por favor, ingrese el nombre del banco.",
  msg_mandatory_bankaccname:
    "Por favor, ingrese el nombre de la cuenta bancaria.",
  msg_mandatory_bankaccno: "Por favor, ingrese el número de cuenta bancaria.",
  msg_bank_pass_notice2:
    "Nota: Si necesita restablecer la dirección de la billetera, comuníquese con el servicio al cliente.",
  msg_username_exist: "El nombre de usuario ya existe.",
  msg_mobileno_exist: "El número de teléfono móvil ha sido registrado.",
  msg_invalid_invitationcode: "Código de invitación inválido.",
  msg_inactive_invitationcode: "El código de invitación no está activo.",
  msg_invitation_notallowed: "Tu referente no tiene permiso para invitar.",
  msg_mandatory_ordercompletebeforerequest:
    "Complete los pedidos antes de enviar una nueva solicitud.",
};
window.es = es;
const sa = {
  msg_progress_title:
    "استخراج با ظرفیت کامل، برآورد نیاز به 3 ثانیه دارد لطفا رابط را ترک نکنید",
  Times: "بار",
  SignInBonus: "پاداش ثبت نام",
  TotalCommission: "کمیسیون امروز",
  TodaysCommission: "کمیسیون امروز",
  TodaysTotalReset: "بازنشانی کل امروز",
  Rejected: "مرفوض",
  Completed: "مكتمل",
  Pending: "قيد الانتظار",
  Remark: "ملاحظة",
  DepositAmount: "مبلغ الإيداع",
  DepositHistory: "تاريخ الودائع",
  WithdrawalAmount: "مبلغ السحب",
  WithdrawalHistory: "تاريخ الانسحاب",
  Submit: "يُقدِّم",
  BindWallet: "ربط المحفظة",
  MandatoryWalletAddress: "عنوان المحفظة*",
  Exchange: "تبادل",
  Commission: "عمولة",
  Notice: "يلاحظ",
  History: "تاريخ",
  OrderHistory: "تاريخ",
  All: "الجميع",
  Confirm: "يتأكد",
  Cancel: "يلغي",
  Home: "بيت",
  Starting: "البدء",
  Record: "سِجِلّ",
  Profile: "حساب تعريفي",
  Recharge: "إعادة الشحن",
  Deposit: "إيداع",
  Withdrawal: "ينسحب",
  Invite: "يدعو",
  FAQ: "الأسئلة المتداولة",
  LuckyDraw: "قرعه کشی شانس",
  BindAccount: "اتصال حساب",
  BankName: "نام بانک",
  BankAccountName: "اسم الحساب البنكي",
  BankAccountNo: "رقم الحساب البنكي",
  Transactions: "عملية",
  Logout: "تسجيل الخروج",
  Language: "لغة",
  CurrentBalance: "الرصيد الحالي",
  ContactUs: "اتصل بنا",
  LoginNameMobileNo: "اسم المستخدم / رقم الهاتف المحمول",
  Password: "كلمة المرور",
  ConfirmPassword: "تأكيد كلمة المرور",
  WithdrawalPassword: "كلمة مرور السحب",
  ChangePassword: "تغيير كلمة المرور",
  ForgotPass: "هل نسيت كلمة المرور؟",
  SignIn: "تسجيل الدخول",
  Register: "التسجيل",
  Username: "اسم المستخدم",
  Login: "تسجيل الدخول",
  RegisterAgreement: "اتفاقية التسجيل",
  MobileNo: "رقم الهاتف المحمول",
  InvitationCode: "رمز الدعوة",
  CreditScore: "درجة الائتمان",
  BackToLogin: "العودة إلى تسجيل الدخول",
  MembershipLevel: "مستوى العضوية",
  TodaysCommission: "عمولة اليوم",
  TotalAmount: "المبلغ الإجمالي",
  ProcessingAmount: "مقدار پردازش",
  AccumulatedCommission: "انباشته کمیسیون",
  LatestEvent: "آخر الأحداث",
  AboutUs: "نبذة عنا",
  TNC: "الشروط والأحكام",
  TeamReport: "تقرير الفريق",
  BindWallet: "ربط المحفظة",
  Certificate: "الشهادة",
  OnlineUsers: "المستخدمون عبر الإنترنت",
  FromLastMonth: "من الشهر الماضي",
  OptimizeDemand: "تحسين الطلب",
  OrderCompletion: "إكمال الطلب",
  OrderQuantity: "طلب الكمية",
  StartNow: "ابدأ الآن",
  AccountBalance: "رصيد الحساب",
  FreezeAmount: "مقدار پردازش",
  Frozen: "پردازش",
  MessageList: "قائمة الرسائل",
  OrderSubmission: "تقديم الطلب",
  CreateTime: "إنشاء الوقت",
  OrderNumber: "رقم الطلب",
  success: "نجاح",
  msg_login_success: "نجاح تسجيل الدخول",
  msg_logout_confirm: "هل أنت متأكد من رغبتك في تسجيل الخروج من الحساب؟",
  msg_workingtime: "وقت العمل",
  msg_depositwithdrawal:
    "بالنسبة لعمليات الإيداع والسحب، يُرجى الاتصال بخدمة العملاء",
  msg_clicktocontactus: "انقر للاتصال بخدمة العملاء",
  msg_accountnotexist: "حساب أو كلمة مرور غير صالحة",
  msg_invalidpassword: "كلمة مرور غير صالحة",
  msg_grab_order_period:
    "يمكن إجراء هذه العملية فقط خلال الوقت المحدد [START]:00 - [END]:00",
  msg_grab_order_disabled: "تم تعطيل هذه العملية. يرجى الاتصال بخدمة العملاء.",
  msg_account_disabled: "تم تعطيل الحساب",
  msg_account_frozen: "تم تجميد وظيفة معاملات الحساب",
  msg_account_gap_amount:
    "رصيد حسابك لا يكفي، فهناك فجوة في [REPLACEVALUE1]. يرجى الاتصال بخدمة العملاء.",
  msg_order_processing_success: "اكتملت معالجة الطلبات",
  msg_progress_note1: "مزامنة أحدث المعلومات...",
  msg_progress_note2: "التحقق من معلومات المنتج...",
  msg_progress_note3: "مطابقة طلبات المنتجات...",
  msg_progress_note4: "معالجة أفضل منتج...",
  msg_receive_withdrawal_transfer: "ستتلقى السحب الخاص بك في غضون نصف ساعة",
  msg_insufficient_creditscore: "درجة ائتمان غير كافية",
  msg_invalid_password: "كلمة مرور غير صالحة",
  msg_input_withdrawalpassword: "يرجى إدخال كلمة مرور السحب",
  msg_please_input_userid: "الرجاء إدخال اسم المستخدم الخاص بك",
  msg_please_input_pass: "الرجاء إدخال كلمة مرور تسجيل الدخول",
  msg_please_input_mobileno: "يرجى إدخال رقم هاتفك المحمول",
  msg_pass_min_length: "يجب ألا يقل طول كلمة المرور عن 8",
  msg_pass_format:
    "يجب أن تحتوي كلمة المرور على حروف وأرقام فقط بطول 8 إلى 12 حرفًا",
  msg_pass_confirm: "الرجاء إدخال كلمة مرور تسجيل الدخول مرة أخرى",
  msg_withpass_min_length: "يجب أن يكون طول كلمة مرور السحب 8 على الأقل",
  msg_withpass_format:
    "يجب أن تحتوي كلمة مرور السحب على حروف وأرقام فقط بطول 8 إلى 12",
  msg_please_input_invitecode: "يرجى إدخال رمز الدعوة",
  msg_balance_insufficient:
    "عدم امکان شروع معامله به دلیل موجودی کمتر از حداقل مقدار فعال سازی، لطفاً برای راهنمایی بیشتر با خدمات مشتری تماس بگیرید",
  msg_orderset_completed:
    "این دور از وظایف تکمیل شده است، لطفا برای مراحل بعدی با خدمات  مشتری تماس بگیرید",
  msg_recharge: "لطفا برای راهنمایی بیشتر با خدمات مشتری تماس بگیرید",
  msg_bank_pass_notice:
    "کاربر گرامی لطفا رمز حساب بانکی خود را در این کادر وارد نکنید. کارکنان ما از شما تقاضای ارائه رمز حساب بانکی خود را نمی کنند.",
  msg_mandatory_bankname: "لطفا نام بانک را وارد کنید",
  msg_mandatory_bankaccname: "لطفا نام حساب بانکی را وارد کنید",
  msg_mandatory_bankaccno: "لطفا شماره حساب بانکی را وارد کنید",
  msg_bank_pass_notice2:
    "نکات: اگر کاربر نیاز به تنظیم مجدد آدرس کیف پول دارد، لطفاً با خدمات مشتری ما تماس بگیرید",
};
window.sa = sa;
const ir = {
  msg_progress_title:
    "استخراج با ظرفیت کامل در حال انجام است. برآورد می‌شود این فرایند ۳ ثانیه طول بکشد. لطفاً صفحه را ترک نکنید.",
  Times: "بار",
  SignInBonus: "پاداش ثبت‌نام",
  TotalCommission: "کمیسیون کل",
  TodaysCommission: "کمیسیون امروز",
  TodaysTotalReset: "بازنشانی کل امروز",
  Rejected: "رد شده",
  Completed: "تکمیل‌شده",
  Pending: "در انتظار",
  Remark: "یادداشت",
  DepositAmount: "مبلغ واریز",
  DepositHistory: "تاریخچه واریز",
  WithdrawalAmount: "مبلغ برداشت",
  WithdrawalHistory: "تاریخچه برداشت",
  Submit: "ارسال",
  BindWallet: "اتصال کیف پول",
  MandatoryWalletAddress: "*آدرس کیف پول الزامی است",
  Exchange: "مبادله",
  Commission: "کمیسیون",
  Notice: "اطلاعیه",
  History: "تاریخچه",
  OrderHistory: "تاریخچه سفارش‌ها",
  All: "همه",
  Confirm: "تأیید",
  Cancel: "لغو",
  Home: "خانه",
  Starting: "شروع",
  Record: "ثبت",
  Profile: "پروفایل",
  Recharge: "شارژ مجدد",
  Deposit: "واریز",
  Withdrawal: "برداشت",
  Invite: "دعوت",
  FAQ: "سؤالات متداول",
  LuckyDraw: "قرعه‌کشی شانس",
  BindAccount: "اتصال حساب",
  BankName: "نام بانک",
  BankAccountName: "نام دارنده حساب",
  BankAccountNo: "شماره حساب بانکی",
  Transactions: "تراکنش‌ها",
  Logout: "خروج",
  Language: "زبان",
  CurrentBalance: "موجودی فعلی",
  ContactUs: "تماس با ما",
  LoginNameMobileNo: "نام کاربری / شماره موبایل",
  Password: "رمز عبور",
  ConfirmPassword: "تأیید رمز عبور",
  WithdrawalPassword: "رمز برداشت",
  ChangePassword: "تغییر رمز عبور",
  NewPassword: "رمز عبور جدید",
  OldPassword: "رمز عبور قبلی",
  ForgotPass: "رمز عبور را فراموش کرده‌اید؟",
  SignIn: "ورود",
  Register: "ثبت‌نام",
  Username: "نام کاربری",
  Login: "ورود",
  RegisterAgreement: "توافق‌نامه ثبت‌نام",
  MobileNo: "شماره موبایل",
  InvitationCode: "کد دعوت",
  CreditScore: "امتیاز اعتباری",
  BackToLogin: "بازگشت به صفحه ورود",
  MembershipLevel: "سطح عضویت",
  TotalAmount: "مبلغ کل",
  ProcessingAmount: "مقدار پردازش",
  AccumulatedCommission: "انباشته کمیسیون",
  LatestEvent: "آخرین رویداد",
  AboutUs: "درباره ما",
  TNC: "شرایط و ضوابط",
  TeamReport: "گزارش تیم",
  Certificate: "گواهی‌نامه",
  OnlineUsers: "کاربران آنلاین",
  FromLastMonth: "از ماه گذشته",
  OptimizeDemand: "بهینه‌سازی تقاضا",
  OrderCompletion: "تکمیل سفارش",
  OrderQuantity: "تعداد سفارش",
  StartNow: "اکنون شروع کنید",
  AccountBalance: "موجودی حساب",
  FreezeAmount: "مقدار مسدود شده",
  Frozen: "مسدود",
  MessageList: "فهرست پیام‌ها",
  OrderSubmission: "ثبت سفارش",
  CreateTime: "زمان ایجاد",
  OrderNumber: "شماره سفارش",
  MyReferralCode: "کد ارجاع من",
  CopyReferralCode: "کپی کد ارجاع",
  Profit: "سود",
  Value: "ارزش",
  Comm: "کمیسیون",
  success: "موفق",
  msg_login_success: "ورود با موفقیت انجام شد",
  msg_logout_confirm:
    "آیا مطمئن هستید که می‌خواهید از حساب کاربری خود خارج شوید؟",
  msg_workingtime: "ساعات کاری",
  msg_depositwithdrawal: "برای واریز یا برداشت لطفاً با پشتیبانی تماس بگیرید.",
  msg_clicktocontactus: "برای تماس با پشتیبانی کلیک کنید",
  msg_accountnotexist: "حساب کاربری یا رمز عبور نامعتبر است",
  msg_invalidpassword: "رمز عبور نامعتبر است",
  msg_grab_order_period:
    "این عملیات فقط در بازه زمانی [START]:00 تا [END]:00 مجاز است.",
  msg_grab_order_disabled:
    "این عملیات غیرفعال شده است. لطفاً با پشتیبانی تماس بگیرید.",
  msg_account_disabled: "حساب غیرفعال شده است",
  msg_account_frozen: "تراکنش‌های این حساب مسدود شده‌اند",
  msg_account_gap_amount:
    "موجودی حساب کافی نیست. کسری: [REPLACEVALUE1]. لطفاً با پشتیبانی تماس بگیرید.",
  msg_order_processing_success: "سفارش با موفقیت پردازش شد",
  msg_progress_note1: "در حال همگام‌سازی آخرین اطلاعات...",
  msg_progress_note2: "در حال بررسی اطلاعات محصول...",
  msg_progress_note3: "در حال تطبیق سفارش‌ها...",
  msg_progress_note4: "در حال پردازش بهترین محصول...",
  msg_receive_withdrawal_transfer: "برداشت شما تا نیم ساعت دیگر انجام خواهد شد",
  msg_insufficient_creditscore: "امتیاز اعتباری کافی نیست",
  msg_invalid_password: "رمز عبور نامعتبر است",
  msg_input_withdrawalpassword: "لطفاً رمز برداشت را وارد کنید",
  msg_please_input_userid: "لطفاً نام کاربری را وارد کنید",
  msg_please_input_pass: "لطفاً رمز عبور را وارد کنید",
  msg_please_input_mobileno: "لطفاً شماره موبایل را وارد کنید",
  msg_pass_min_length: "رمز عبور باید حداقل ۸ کاراکتر باشد",
  msg_pass_format:
    "رمز عبور باید بین ۸ تا ۱۲ کاراکتر و فقط شامل حروف و اعداد باشد",
  msg_pass_confirm: "لطفاً رمز عبور را مجدداً وارد کنید",
  msg_withpass_min_length: "رمز برداشت باید حداقل ۸ کاراکتر باشد",
  msg_withpass_format:
    "رمز برداشت باید بین ۸ تا ۱۲ کاراکتر و فقط شامل حروف و اعداد باشد",
  msg_please_input_invitecode: "لطفاً کد دعوت را وارد کنید",
  msg_balance_insufficient:
    "امکان شروع معامله وجود ندارد زیرا موجودی کمتر از مقدار فعال‌سازی است. لطفاً با پشتیبانی تماس بگیرید.",
  msg_orderset_completed:
    "این مرحله از سفارش‌ها تکمیل شده است. لطفاً برای ادامه با پشتیبانی تماس بگیرید.",
  msg_recharge: "لطفاً شماره حساب بانکی را وارد کنید",
  msg_bank_pass_notice:
    "کاربر گرامی، لطفاً رمز حساب بانکی خود را در این قسمت وارد نکنید. ما هرگز رمز بانکی شما را درخواست نمی‌کنیم.",
  msg_mandatory_bankname: "لطفاً نام بانک را وارد کنید",
  msg_mandatory_bankaccname: "لطفاً نام صاحب حساب را وارد کنید",
  msg_mandatory_bankaccno: "لطفاً شماره حساب بانکی را وارد کنید",
  msg_bank_pass_notice2:
    "نکته: برای تغییر آدرس کیف پول، لطفاً با پشتیبانی تماس بگیرید",
};
window.ir = ir;
const ru = {
  Home: "Главная",
  Boost: "способствовать росту",
  Rejected: "Отклоненный",
  Completed: "Завершенный",
  Pending: "В ожидании",
  Remark: "Примечание",
  DepositAmount: "Сумма депозита",
  DepositHistory: "История депозитов",
  WithdrawalAmount: "Сумма вывода",
  WithdrawalHistory: "История вывода средств",
  TopWithdrawal: "верхний вывод",
  Recharge: "Пополнить",
  Withdrawal: "Вывод средств",
  Transaction: "Транзакция",
  Invite: "Пригласите",
  HOME: "дом",
  Starting: "Начало",
  Record: "Запись",
  Profile: "Профиль",
  ProductName: "Название продукта",
  ProductNumber: "Номер продукта",
  OrderHistory: "История заказов",
  All: "все",
  BindWallet: "Переплетенный кошелек",
  Logout: "Выход из системы",
  Language: "язык",
  MandatoryWalletAddress: "*Адрес кошелька",
  Exchange: "Имя биржи",
  Commission: "вознаграждение",
  CurrentBalance: "Текущий баланс",
  ContactUs: "Свяжитесь с нами",
  LoginNameMobileNo: "Имя пользователя / номер мобильного телефона",
  Password: "Пароль",
  ConfirmPassword: "Подтвердите пароль",
  WithdrawalPassword: "Пароль для снятия денег",
  ChangePassword: "Изменить пароль",
  ForgotPass: "Забыли пароль?",
  SignIn: "Войти",
  Register: "Регистрация",
  Username: "Имя пользователя",
  Login: "авторизоваться",
  RegisterAgreement: "Регистрационное соглашение",
  MobileNo: "Мобильный Нет",
  InvitationCode: "Код приглашения",
  CreditScore: "Кредитный балл",
  BackToLogin: "Назад К входу",
  MembershipLevel: "Уровень членства",
  TodaysCommission: "Сегодняшняя комиссия",
  TodaysTotalReset: "Сегодняшний общий сброс",
  TotalCommission: "Общая комиссия",
  TotalAmount: "Общая сумма",
  LatestEvent: "Последнее событие",
  AboutUs: "О нас",
  TNC: "T&C",
  TeamReport: "Отчет команды",
  BindWallet: "Переплетенный кошелек",
  Certificate: "Сертификат",
  OnlineUsers: "Онлайн-пользователи",
  FromLastMonth: "Из прошлого месяца",
  OrderCompletion: "Завершение заказа",
  OptimizeDemand: "Оптимизация спроса",
  OrderQuantity: "Заказ Количество",
  Confirm: "Подтверждать",
  Cancel: "Отмена",
  Submit: "подавать",
  Profit: "Прибыль",
  Value: "Ценить",
  Completed: "Terminado",
  StartNow: "Начните прямо сейчас",
  AccountBalance: "Остаток на счете",
  FreezeAmount: "Сумма обработки",
  Frozen: "Обработка",
  MessageList: "Список сообщений",
  OrderSubmission: "Подача заказа",
  CreateTime: "Создать время",
  OrderNumber: "Номер заказа",
  OrderDetails: "Детали заказа",
  MyReferralCode: "Мой реферальный код",
  CopyReferralCode: "Скопируйте реферальный код",
  success: "успех",
  msg_login_success: "Успешное вхождение в систему",
  msg_logout_confirm: "Вы уверены, что хотите выйти из учетной записи?",
  msg_workingtime: "Время работы",
  msg_depositwithdrawal:
    "По вопросам пополнения и снятия средств, пожалуйста, обращайтесь в нашу службу поддержки клиентов",
  msg_clicktocontactus:
    "Нажмите, чтобы связаться со службой поддержки клиентов",
  msg_accountnotexist: "Неверная учетная запись или пароль",
  msg_invalidpassword: "Неверный пароль",
  msg_grab_order_period:
    "Эта операция может быть выполнена только в течение указанного времени [START]:00 - [END]:00",
  msg_withdrawalamount_range:
    "Лимит на снятие средств составляет [MINAMT] - [MAXAMT]",
  msg_withdrawalamount_reservedamt:
    "Первый вывод должен быть зарезервирован [MINAMT]",
  msg_grab_order_disabled:
    "Эта операция отключена. Обратитесь в службу поддержки клиентов.",
  msg_account_disabled: "Учетная запись была отключена",
  msg_account_frozen: "Функция операций со счетами была заморожена",
  msg_account_gap_amount:
    "Баланс вашего счета недостаточен, существует разрыв в [REPLACEVALUE1]. Обратитесь в службу поддержки клиентов.",
  msg_order_processing_success: "Обработка заказа завершена",
  msg_progress_title:
    "на полную мощность, Estimate нужно<span style='color: red'> &nbsp;3s&nbsp;</span>Пожалуйста, не покидайте интерфейс!",
  msg_progress_note1: "Синхронизация последней информации...",
  msg_progress_note2: "Проверка информации о продукте...",
  msg_progress_note3: "Сопоставление заказов на продукцию...",
  msg_progress_note4: "Обработка лучшего продукта...",
  msg_receive_withdrawal_transfer: "Вы получите деньги в течение получаса",
  msg_insufficient_creditbalance: "Недостаточный кредит",
  msg_insufficient_creditscore: "Недостаточная кредитная история",
  msg_invalid_password: "Неверный пароль",
  msg_input_withdrawalpassword: "Пожалуйста, введите пароль для вывода средств",
  msg_please_input_userid: "Пожалуйста, введите ваше имя пользователя",
  msg_please_input_pass: "Пожалуйста, введите пароль для входа в систему",
  msg_please_input_mobileno:
    "Пожалуйста, введите номер вашего мобильного телефона",
  msg_pass_min_length: "Длина пароля должна быть не менее 6",
  msg_pass_format:
    "Пароль должен содержать только буквы и цифры длиной от 6 до 50",
  msg_pass_confirm: "Пожалуйста, введите пароль для входа еще раз",
  msg_withpass_min_length: "Длина пароля для снятия должна быть не менее 6",
  msg_withpass_format:
    "Пароль для вывода средств должен содержать только буквы и цифры длиной от 6 до 50",
  msg_please_input_invitecode: "Введите код приглашения",
  msg_balance_insufficient:
    "Невозможно начать торговлю из-за того, что баланс ниже минимального значения активации. Обратитесь в службу поддержки клиентов для получения дополнительной помощи.",
  msg_recharge:
    "Пожалуйста, свяжитесь со службой поддержки клиентов для получения дополнительной помощи",
  msg_bank_pass_notice:
    "Уважаемый пользователь, Пожалуйста, не вводите в это поле пароль своего банковского счета. Наши сотрудники не потребуют от вас предоставить пароль от банковского счета..",
  msg_mandatory_bankname: "Пожалуйста, введите название банка",
  msg_mandatory_bankaccname: "Пожалуйста, введите название банковского счета",
  msg_mandatory_bankaccno: "Пожалуйста, введите номер банковского счета",
  msg_bank_pass_notice2:
    "Примечания: Если пользователю необходимо сбросить адрес кошелька, обратитесь в нашу службу поддержки клиентов.",
  msg_username_exist: "Дублированное имя пользователя",
  msg_mobileno_exist: "Номер мобильного телефона зарегистрирован",
  msg_invalid_invitationcode: "неверный код приглашения",
  msg_inactive_invitationcode: "код приглашения неактивен",
  msg_invitation_notallowed: "у вашего реферера нет разрешения приглашать",
  msg_mandatory_ordercompletebeforerequest:
    "Завершите заказы, прежде чем подавать новый запрос",
};
window.ru = ru;
const fr = {
  Home: "Accueil",
  Boost: "Boost",
  Rejected: "Rejeté",
  Completed: "Terminé",
  Pending: "En attente",
  Profile: "Profil",
  Record: "Enregistrer",
  Remark: "Remarque",
  Starting: "Départ",
  Transactions: "Transactions",
  DepositAmount: "Montant du dépôt",
  DepositHistory: "Historique des dépôts",
  WithdrawalAmount: "Montant du retrait",
  WithdrawalHistory: "Historique des retraits",
  TopWithdrawal: "Retrait principal",
  Withdrawal: "Retrait",
  LuckyDraw: "Tirage au sort",
  BindAccount: "Lier un compte",
  BankName: "Nom de la banque",
  BankAccountName: "Nom du compte bancaire",
  BankAccountNo: "Numéro de compte bancaire",
  Recharge: "Recharger",
  ProductName: "Nom du produit",
  ProductNumber: "Numéro du produit",
  OrderHistory: "Historique des commandes",
  All: "Tout",
  BindWallet: "Lier un portefeuille",
  Logout: "Déconnexion",
  Language: "langue",
  MandatoryWalletAddress: "*Adresse du portefeuille",
  Exchange: "Échanger",
  Commission: "Commission",
  CurrentBalance: "Solde actuel",
  ContactUs: "Nous contacter",
  LoginNameMobileNo: "Nom d'utilisateur / Numéro de mobile",
  Password: "Mot de passe",
  ConfirmPassword: "Confirmer le mot de passe",
  WithdrawalPassword: "Mot de passe de retrait",
  ChangePassword: "Changer le mot de passe",
  ForgotPass: "Mot de passe oublié ?",
  SignIn: "Se connecter",
  Register: "S'inscrire",
  Username: "Nom d'utilisateur",
  Login: "Connexion",
  RegisterAgreement: "Accord d'inscription",
  MobileNo: "Numéro de mobile",
  InvitationCode: "Code d'invitation",
  CreditScore: "Score de crédit",
  BackToLogin: "Retour à la connexion",
  MembershipLevel: "Niveau d'adhésion",
  TodaysCommission: "Commission du jour",
  TodaysTotalReset: "La réinitialisation totale d'aujourd'hui",
  TotalCommission: "Commission totale",
  TotalAmount: "Montant total",
  LatestEvent: "Dernier événement",
  AboutUs: "À propos de nous",
  TNC: "T&C",
  TeamReport: "Rapport d'équipe",
  Certificate: "Certificat",
  OnlineUsers: "Utilisateurs en ligne",
  FromLastMonth: "Depuis le mois dernier",
  OptimizeDemand: "Optimiser la demande",
  OrderCompletion: "Achèvement de la commande",
  OrderQuantity: "Quantité de commande",
  Confirm: "Confirmer",
  Cancel: "Annuler",
  Submit: "Soumettre",
  Profit: "Profit",
  Value: "Valeur",
  StartNow: "Commencer maintenant",
  AccountBalance: "Solde du compte",
  FreezeAmount: "Montant en traitement",
  Frozen: "En traitement",
  MessageList: "Liste des messages",
  OrderSubmission: "Soumission de commande",
  CreateTime: "Heure de création",
  OrderNumber: "Numéro de commande",
  OrderDetails: "Détails de la commande",
  MyReferralCode: "Mon code de parrainage",
  CopyReferralCode: "Copier le code de parrainage",
  success: "succès",
  msg_login_success: "Connexion réussie",
  msg_logout_confirm: "Êtes-vous sûr de vouloir vous déconnecter ?",
  msg_workingtime: "Heures de travail",
  msg_depositwithdrawal:
    "Pour les dépôts et retraits, veuillez contacter notre service client",
  msg_clicktocontactus: "Cliquez pour contacter le service client",
  msg_accountnotexist: "Compte ou mot de passe invalide",
  msg_invalidpassword: "Mot de passe invalide",
  msg_grab_order_period:
    "Cette opération peut être effectuée uniquement pendant les heures spécifiées [START]:00 - [END]:00",
  msg_withdrawalamount_range: "La limite de retrait est de [MINAMT] - [MAXAMT]",
  msg_withdrawalamount_reservedamt:
    "Le premier retrait doit être réservé [MINAMT]",
  msg_grab_order_disabled:
    "Cette opération est désactivée. Veuillez contacter le service client.",
  msg_account_disabled: "Le compte a été désactivé",
  msg_account_frozen: "La fonction de transaction du compte a été gelée",
  msg_account_gap_amount:
    "Votre solde est insuffisant, il manque [REPLACEVALUE1]. Veuillez contacter le service client.",
  msg_order_processing_success: "Traitement de la commande terminé",
  msg_progress_title:
    "Extraction à pleine capacité, estimation<span style='color: red'> &nbsp;3s&nbsp;</span>Ne quittez pas l'interface !",
  msg_progress_note1: "Synchronisation des dernières informations...",
  msg_progress_note2: "Vérification des informations sur le produit...",
  msg_progress_note3: "Appariement des commandes de produits...",
  msg_progress_note4: "Traitement du meilleur produit...",
  msg_receive_withdrawal_transfer:
    "Vous recevrez votre retrait dans une demi-heure",
  msg_insufficient_creditbalance: "Crédit insuffisant",
  msg_insufficient_creditscore: "Score de crédit insuffisant",
  msg_invalid_password: "Mot de passe invalide",
  msg_input_withdrawalpassword: "Veuillez entrer le mot de passe de retrait",
  msg_please_input_userid: "Veuillez entrer votre nom d'utilisateur",
  msg_please_input_pass: "Veuillez entrer le mot de passe",
  msg_please_input_mobileno: "Veuillez entrer votre numéro de mobile",
  msg_pass_min_length:
    "La longueur du mot de passe doit être d'au moins 8 caractères",
  msg_pass_format:
    "Le mot de passe doit contenir uniquement des lettres et des chiffres, avec une longueur de 8 à 50",
  msg_pass_confirm: "Veuillez entrer à nouveau le mot de passe",
  msg_withpass_min_length:
    "La longueur du mot de passe de retrait doit être d'au moins 8 caractères",
  msg_withpass_format:
    "Le mot de passe de retrait doit contenir uniquement des lettres et des chiffres, avec une longueur de 8 à 50",
  msg_please_input_invitecode: "Veuillez entrer le code d'invitation",
  msg_balance_insufficient:
    "Impossible de commencer à trader car le solde est inférieur à la valeur d'activation minimale. Veuillez contacter le service client pour plus d'assistance",
  msg_recharge: "Veuillez contacter le service client pour plus d'assistance",
  msg_bank_pass_notice:
    "Cher utilisateur, veuillez ne pas entrer votre propre mot de passe de compte bancaire dans cette case. Notre personnel ne vous demandera pas de fournir votre mot de passe de compte bancaire.",
  msg_mandatory_bankname: "Veuillez entrer le nom de la banque",
  msg_mandatory_bankaccname: "Veuillez entrer le nom du compte bancaire",
  msg_mandatory_bankaccno: "Veuillez entrer le numéro du compte bancaire",
  msg_bank_pass_notice2:
    "Remarque : Si l'utilisateur doit réinitialiser l'adresse du portefeuille, veuillez contacter notre service client.",
  msg_luckydraw_insufficientdrawcount: "Nombre de tirages insuffisant",
  msg_username_exist: "Nom d'utilisateur en double",
  msg_mobileno_exist: "Le numéro de téléphone portable a été enregistré",
  msg_invalid_invitationcode: "Code d'invitation invalide",
  msg_inactive_invitationcode: "Code d'invitation inactif",
  msg_invitation_notallowed: "Votre parrain n'a pas la permission d'inviter",
  msg_mandatory_ordercompletebeforerequest:
    "Terminez vos commandes avant de soumettre une nouvelle demande",
};
window.fr = fr;
var tr = {
  Home: "Ana Sayfa",
  Boost: "Hızlandır",
  Rejected: "Reddedildi",
  Completed: "Tamamlandı",
  Pending: "Beklemede",
  Profile: "Profil",
  Record: "Kayıt",
  Remark: "Not",
  Starting: "Başlıyor",
  Transactions: "İşlemler",
  DepositAmount: "Yatırma Tutarı",
  DepositHistory: "Mevduat Geçmişi",
  WithdrawalAmount: "Çekim Tutarı",
  WithdrawalHistory: "Çekim Geçmişi",
  TopWithdrawal: "En Yüksek Çekim",
  Withdrawal: "Çekim",
  Invite: "Davet Et",
  LuckyDraw: "Şans Çekilişi",
  BindAccount: "Hesap Bağla",
  BankName: "Banka Adı",
  BankAccountName: "Banka Hesap Adı",
  BankAccountNo: "Banka Hesap No",
  Recharge: "Yükleme",
  ProductName: "Ürün Adı",
  ProductNumber: "Ürün Numarası",
  OrderHistory: "Sipariş Geçmişi",
  All: "Tümü",
  BindWallet: "Cüzdan Bağla",
  Logout: "Çıkış Yap",
  Language: "Dil",
  MandatoryWalletAddress: "*Cüzdan Adresi",
  Exchange: "Döviz",
  Commission: "Komisyon",
  CurrentBalance: "Mevcut Bakiye",
  ContactUs: "Bize Ulaşın",
  LoginNameMobileNo: "Kullanıcı Adı / Telefon Numarası",
  Password: "Şifre",
  ConfirmPassword: "Şifreyi Onayla",
  WithdrawalPassword: "Çekim Şifresi",
  ChangePassword: "Şifre Değiştir",
  ForgotPass: "Şifrenizi mi unuttunuz?",
  SignIn: "Giriş Yap",
  Register: "Kayıt Ol",
  Username: "Kullanıcı Adı",
  Login: "Giriş Yap",
  RegisterAgreement: "Kayıt Sözleşmesi",
  MobileNo: "Telefon Numarası",
  InvitationCode: "Davet Kodu",
  CreditScore: "Kredi Puanı",
  BackToLogin: "Girişe Geri Dön",
  MembershipLevel: "Üyelik Seviyesi",
  TodaysCommission: "Bugünkü Komisyon",
  TodaysTotalReset: "Bugünkü Toplam Sıfırlama",
  TotalCommission: "Toplam Komisyon",
  TotalAmount: "Toplam Tutar",
  LatestEvent: "Son Etkinlik",
  AboutUs: "Hakkımızda",
  TNC: "Şartlar ve Koşullar",
  TeamReport: "Takım Raporu",
  Certificate: "Sertifika",
  OnlineUsers: "Çevrimiçi Kullanıcılar",
  FromLastMonth: "Geçen Aydan",
  OptimizeDemand: "Talebi Optimize Et",
  OrderCompletion: "Sipariş Tamamlanması",
  OrderQuantity: "Sipariş Miktarı",
  Confirm: "Onayla",
  Cancel: "İptal",
  Submit: "Gönder",
  Profit: "Kar",
  Value: "Değer",
  StartNow: "Şimdi Başla",
  AccountBalance: "Hesap Bakiyesi",
  FreezeAmount: "İşlemdeki Tutar",
  Frozen: "İşlemde",
  MessageList: "Mesaj Listesi",
  OrderSubmission: "Sipariş Gönderimi",
  CreateTime: "Oluşturma Zamanı",
  OrderNumber: "Sipariş Numarası",
  OrderDetails: "Sipariş Detayları",
  MyReferralCode: "Benim Referans Kodum",
  CopyReferralCode: "Referans Kodunu Kopyala",
  success: "başarı",
  msg_login_success: "Giriş Başarılı",
  msg_logout_confirm: "Hesaptan çıkış yapmak istediğinizden emin misiniz?",
  msg_workingtime: "Çalışma saati",
  msg_depositwithdrawal:
    "Para yatırma ve çekme için lütfen Müşteri Hizmetleri ile iletişime geçin",
  msg_clicktocontactus: "Müşteri Hizmetlerine Ulaşmak İçin Tıklayın",
  msg_accountnotexist: "Geçersiz hesap veya şifre",
  msg_invalidpassword: "Geçersiz şifre",
  msg_grab_order_period:
    "Bu işlem yalnızca belirlenen saatler arasında yapılabilir: [START]:00 - [END]:00",
  msg_withdrawalamount_range: "Çekim limiti [MINAMT] - [MAXAMT] arasındadır",
  msg_withdrawalamount_reservedamt:
    "İlk para çekme işlemi için rezervasyon yaptırılmalıdır [MINAMT]",
  msg_grab_order_disabled:
    "Bu işlem devre dışı bırakılmıştır. Lütfen müşteri hizmetleri ile iletişime geçin.",
  msg_account_disabled: "Hesap devre dışı bırakıldı",
  msg_account_frozen: "Hesap işlem özelliği donduruldu",
  msg_account_gap_amount:
    "Hesap bakiyeniz yetersiz, [REPLACEVALUE1] kadar eksik. Lütfen müşteri hizmetleri ile iletişime geçin.",
  msg_order_processing_success: "Sipariş işleme tamamlandı",
  msg_progress_title:
    "Tam kapasiteyle çıkarılıyor, Tahmini süre<span style='color: red'> &nbsp;3s&nbsp;</span> Lütfen arayüzden ayrılmayın!",
  msg_progress_note1: "Son bilgiler senkronize ediliyor...",
  msg_progress_note2: "Ürün bilgileri kontrol ediliyor...",
  msg_progress_note3: "Ürün siparişleri eşleştiriliyor...",
  msg_progress_note4: "En iyi ürün işleniyor...",
  msg_receive_withdrawal_transfer:
    "Çekiminiz yarım saat içinde hesabınıza ulaşacaktır",
  msg_insufficient_creditbalance: "Yetersiz kredi",
  msg_insufficient_creditscore: "Yetersiz kredi puanı",
  msg_invalid_password: "Geçersiz Şifre",
  msg_input_withdrawalpassword: "Lütfen çekim şifresini girin",
  msg_please_input_userid: "Lütfen kullanıcı adınızı girin",
  msg_please_input_pass: "Lütfen giriş şifresini girin",
  msg_please_input_mobileno: "Lütfen telefon numaranızı girin",
  msg_pass_min_length: "Şifre uzunluğu en az 8 olmalıdır",
  msg_pass_format:
    "Şifre yalnızca harf ve rakamlardan oluşmalı ve 8 ila 50 karakter uzunluğunda olmalıdır",
  msg_pass_confirm: "Lütfen giriş şifresini tekrar girin",
  msg_withpass_min_length: "Çekim şifresi en az 8 karakter olmalıdır",
  msg_withpass_format:
    "Çekim şifresi yalnızca harf ve rakamlardan oluşmalı ve 8 ila 50 karakter uzunluğunda olmalıdır",
  msg_please_input_invitecode: "Lütfen davet kodunu girin",
  msg_balance_insufficient:
    "Bakiyeniz minimum etkinleştirme değerinin altında olduğu için ticarete başlanamadı. Daha fazla bilgi için müşteri hizmetlerine başvurun",
  msg_recharge: "Daha fazla bilgi için müşteri hizmetlerine başvurun",
  msg_bank_pass_notice:
    "Sayın kullanıcı, lütfen bu kutuya kendi banka hesabı şifrenizi girmeyin. Çalışanlarımız banka şifrenizi talep etmeyecektir.",
  msg_mandatory_bankname: "Lütfen banka adını girin",
  msg_mandatory_bankaccname: "Lütfen banka hesap adını girin",
  msg_mandatory_bankaccno: "Lütfen banka hesap numarasını girin",
  msg_bank_pass_notice2:
    "Not: Kullanıcı cüzdan adresini sıfırlamak istiyorsa, lütfen müşteri hizmetleri ile iletişime geçin.",
  msg_luckydraw_insufficientdrawcount: "Çekiliş hakkı yetersiz",
  msg_username_exist: "Kullanıcı adı zaten mevcut",
  msg_mobileno_exist: "Cep telefonu numarası kaydedildi",
  msg_invalid_invitationcode: "Geçersiz davet kodu",
  msg_inactive_invitationcode: "Davet kodu aktif değil",
  msg_invitation_notallowed: "Referans olan kişinin davet etme izni yok",
  msg_mandatory_ordercompletebeforerequest:
    "Yeni bir talep göndermeden önce siparişlerinizi tamamlayın",
};
window.tr = tr;
var pt = {
  Home: "Início",
  Boost: "Aumentar",
  Rejected: "Rejeitado",
  Completed: "Concluído",
  Pending: "Pendente",
  Profile: "Perfil",
  Record: "Registro",
  Remark: "Observação",
  Starting: "Iniciando",
  Transactions: "Transações",
  DepositAmount: "Valor do depósito",
  DepositHistory: "Histórico de Depósitos",
  WithdrawalAmount: "Valor de Retirada",
  WithdrawalHistory: "Histórico de Retiradas",
  TopWithdrawal: "Maior Retirada",
  Withdrawal: "Retirada",
  Invite: "Convidar",
  LuckyDraw: "Sorteio",
  BindAccount: "Vincular Conta",
  BankName: "Nome do Banco",
  BankAccountName: "Nome da Conta Bancária",
  BankAccountNo: "Número da Conta Bancária",
  Recharge: "Recarregar",
  ProductName: "Nome do Produto",
  ProductNumber: "Número do Produto",
  OrderHistory: "Histórico de Pedidos",
  All: "Todos",
  BindWallet: "Vincular Carteira",
  Logout: "Sair",
  Language: "Idioma",
  MandatoryWalletAddress: "*Endereço da Carteira",
  Exchange: "Câmbio",
  Commission: "Comissão",
  CurrentBalance: "Saldo Atual",
  ContactUs: "Fale Conosco",
  LoginNameMobileNo: "Usuário / Número de Telefone",
  Password: "Senha",
  ConfirmPassword: "Confirmar Senha",
  WithdrawalPassword: "Senha de Retirada",
  ChangePassword: "Alterar Senha",
  ForgotPass: "Esqueceu a senha?",
  SignIn: "Entrar",
  Register: "Registrar",
  Username: "Usuário",
  Login: "Login",
  RegisterAgreement: "Acordo de Registro",
  MobileNo: "Número de Telefone",
  InvitationCode: "Código de Convite",
  CreditScore: "Pontuação de Crédito",
  BackToLogin: "Voltar ao Login",
  MembershipLevel: "Nível de Membro",
  TodaysCommission: "Comissão de Hoje",
  TodaysTotalReset: "Reinicialização total de hoje",
  TotalCommission: "Comissão Total",
  TotalAmount: "Valor Total",
  LatestEvent: "Último Evento",
  AboutUs: "Sobre Nós",
  TNC: "Termos e Condições",
  TeamReport: "Relatório da Equipe",
  Certificate: "Certificado",
  OnlineUsers: "Usuários Online",
  FromLastMonth: "Desde o Mês Passado",
  OptimizeDemand: "Otimizar Demanda",
  OrderCompletion: "Conclusão do Pedido",
  OrderQuantity: "Quantidade de Pedidos",
  Confirm: "Confirmar",
  Cancel: "Cancelar",
  Submit: "Enviar",
  Profit: "Lucro",
  Value: "Valor",
  StartNow: "Comece Agora",
  AccountBalance: "Saldo da Conta",
  FreezeAmount: "Quantia em Processamento",
  Frozen: "Em Processamento",
  MessageList: "Lista de Mensagens",
  OrderSubmission: "Envio de Pedido",
  CreateTime: "Hora de Criação",
  OrderNumber: "Número do Pedido",
  OrderDetails: "Detalhes do Pedido",
  MyReferralCode: "Meu Código de Referência",
  CopyReferralCode: "Copiar Código de Referência",
  success: "sucesso",
  msg_login_success: "Login Bem-sucedido",
  msg_logout_confirm: "Tem certeza de que deseja sair da conta?",
  msg_workingtime: "Horário de Funcionamento",
  msg_depositwithdrawal:
    "Para depósitos e retiradas, entre em contato com nosso Atendimento ao Cliente",
  msg_clicktocontactus: "Clique para Entrar em Contato com o Atendimento",
  msg_accountnotexist: "Conta ou senha inválida",
  msg_invalidpassword: "Senha inválida",
  msg_grab_order_period:
    "Esta operação só pode ser realizada durante o período especificado [START]:00 - [END]:00",
  msg_withdrawalamount_range: "O limite de retirada é [MINAMT] - [MAXAMT]",
  msg_withdrawalamount_reservedamt:
    "İlk para çekme işlemi için rezervasyon yaptırılmalıdır [MINAMT]",
  msg_grab_order_disabled:
    "Esta operação foi desativada. Entre em contato com o Atendimento ao Cliente.",
  msg_account_disabled: "A conta foi desativada",
  msg_account_frozen: "A função de transação da conta foi congelada",
  msg_account_gap_amount:
    "Seu saldo é insuficiente. Há uma diferença de [REPLACEVALUE1]. Entre em contato com o Atendimento ao Cliente.",
  msg_order_processing_success: "Processamento do pedido concluído",
  msg_progress_title:
    "Extraindo em capacidade máxima, estimativa de<span style='color: red'> &nbsp;3s&nbsp;</span>Não saia da interface!",
  msg_progress_note1: "Sincronizando informações mais recentes...",
  msg_progress_note2: "Verificando informações do produto...",
  msg_progress_note3: "Correspondendo pedidos de produtos...",
  msg_progress_note4: "Processando o melhor produto...",
  msg_receive_withdrawal_transfer:
    "Você receberá sua retirada dentro de meia hora",
  msg_insufficient_creditbalance: "Crédito insuficiente",
  msg_insufficient_creditscore: "Pontuação de crédito insuficiente",
  msg_invalid_password: "Senha inválida",
  msg_input_withdrawalpassword: "Por favor, insira a senha de retirada",
  msg_please_input_userid: "Por favor, insira seu nome de usuário",
  msg_please_input_pass: "Por favor, insira sua senha",
  msg_please_input_mobileno: "Por favor, insira seu número de telefone",
  msg_pass_min_length: "A senha deve ter pelo menos 8 caracteres",
  msg_pass_format:
    "A senha deve conter apenas letras e números com 8 a 50 caracteres",
  msg_pass_confirm: "Por favor, insira novamente a senha de login",
  msg_withpass_min_length:
    "A senha de retirada deve ter pelo menos 8 caracteres",
  msg_withpass_format:
    "A senha de retirada deve conter apenas letras e números com 8 a 50 caracteres",
  msg_please_input_invitecode: "Por favor, insira o código de convite",
  msg_balance_insufficient:
    "Não é possível iniciar negociações devido ao saldo estar abaixo do valor mínimo de ativação. Entre em contato com o Atendimento ao Cliente para mais informações.",
  msg_recharge:
    "Entre em contato com o Atendimento ao Cliente para mais informações.",
  msg_bank_pass_notice:
    "Prezado usuário, não insira sua senha de conta bancária neste campo. Nossos funcionários não solicitarão sua senha bancária.",
  msg_mandatory_bankname: "Por favor, insira o nome do banco",
  msg_mandatory_bankaccname: "Por favor, insira o nome da conta bancária",
  msg_mandatory_bankaccno: "Por favor, insira o número da conta bancária",
  msg_bank_pass_notice2:
    "Observação: Caso precise redefinir o endereço da carteira, entre em contato com o Atendimento ao Cliente.",
  msg_luckydraw_insufficientdrawcount: "Número insuficiente de tentativas",
  msg_username_exist: "Nome de usuário já existente",
  msg_mobileno_exist: "O número do celular foi registrado",
  msg_invalid_invitationcode: "Código de convite inválido",
  msg_inactive_invitationcode: "Código de convite inativo",
  msg_invitation_notallowed: "Seu patrocinador não tem permissão para convidar",
  msg_mandatory_ordercompletebeforerequest:
    "Conclua seus pedidos antes de enviar uma nova solicitação",
};
window.pt = pt;
var pl = {
  Home: "Strona główna",
  Boost: "Wzmocnij",
  Rejected: "Odrzucone",
  Completed: "Zakończone",
  Pending: "Oczekujące",
  Profile: "Profil",
  Record: "Rekord",
  Remark: "Uwagi",
  Starting: "Rozpoczęcie",
  Transactions: "Transakcje",
  DepositAmount: "Kwota depozytu",
  DepositHistory: "Historia depozytów",
  WithdrawalAmount: "Kwota wypłaty",
  WithdrawalHistory: "Historia wypłat",
  TopWithdrawal: "Najwyższa wypłata",
  Withdrawal: "Wypłata",
  Invite: "Zaproś",
  LuckyDraw: "Losowanie",
  BindAccount: "Połącz konto",
  BankName: "Nazwa banku",
  BankAccountName: "Nazwa rachunku bankowego",
  BankAccountNo: "Numer rachunku bankowego",
  Recharge: "Doładowanie",
  ProductName: "Nazwa produktu",
  ProductNumber: "Numer produktu",
  OrderHistory: "Historia zamówień",
  All: "Wszystkie",
  BindWallet: "Połącz portfel",
  Logout: "Wyloguj się",
  Language: "Język",
  MandatoryWalletAddress: "*Adres portfela",
  Exchange: "Wymiana",
  Commission: "Prowizja",
  CurrentBalance: "Obecny stan konta",
  ContactUs: "Skontaktuj się z nami",
  LoginNameMobileNo: "Nazwa użytkownika / Numer telefonu",
  Password: "Hasło",
  ConfirmPassword: "Potwierdź hasło",
  WithdrawalPassword: "Hasło do wypłat",
  ChangePassword: "Zmień hasło",
  ForgotPass: "Zapomniałeś hasła?",
  SignIn: "Zaloguj się",
  Register: "Zarejestruj się",
  Username: "Nazwa użytkownika",
  Login: "Logowanie",
  RegisterAgreement: "Regulamin rejestracji",
  MobileNo: "Numer telefonu",
  InvitationCode: "Kod zaproszenia",
  CreditScore: "Wynik kredytowy",
  BackToLogin: "Powrót do logowania",
  MembershipLevel: "Poziom członkostwa",
  TodaysCommission: "Dzisiejsza prowizja",
  TodaysTotalReset: "Dzisiejszy całkowity reset",
  TotalCommission: "Całkowita prowizja",
  TotalAmount: "Łączna kwota",
  LatestEvent: "Najnowsze wydarzenie",
  AboutUs: "O nas",
  TNC: "Regulamin",
  TeamReport: "Raport zespołu",
  Certificate: "Certyfikat",
  OnlineUsers: "Użytkownicy online",
  FromLastMonth: "Od zeszłego miesiąca",
  OptimizeDemand: "Optymalizacja popytu",
  OrderCompletion: "Realizacja zamówienia",
  OrderQuantity: "Ilość zamówień",
  Confirm: "Potwierdź",
  Cancel: "Anuluj",
  Submit: "Wyślij",
  Profit: "Zysk",
  Value: "Wartość",
  StartNow: "Zacznij teraz",
  AccountBalance: "Stan konta",
  FreezeAmount: "Przetwarzana kwota",
  Frozen: "W przetwarzaniu",
  MessageList: "Lista wiadomości",
  OrderSubmission: "Składanie zamówienia",
  CreateTime: "Czas utworzenia",
  OrderNumber: "Numer zamówienia",
  OrderDetails: "Szczegóły zamówienia",
  MyReferralCode: "Mój kod referencyjny",
  CopyReferralCode: "Skopiuj kod referencyjny",
  success: "sukces",
  msg_login_success: "Pomyślnie zalogowano",
  msg_logout_confirm: "Czy na pewno chcesz się wylogować?",
  msg_workingtime: "Godziny pracy",
  msg_depositwithdrawal:
    "W sprawie wpłat i wypłat prosimy o kontakt z Obsługą Klienta",
  msg_clicktocontactus: "Kliknij, aby skontaktować się z Obsługą Klienta",
  msg_accountnotexist: "Nieprawidłowe konto lub hasło",
  msg_invalidpassword: "Nieprawidłowe hasło",
  msg_grab_order_period:
    "Operacja dostępna tylko w określonym czasie [START]:00 - [END]:00",
  msg_withdrawalamount_range: "Limit wypłat wynosi od [MINAMT] do [MAXAMT]",
  msg_withdrawalamount_reservedamt:
    "O primeiro serviço deve ser reservado [MINAMT]",
  msg_grab_order_disabled:
    "Operacja wyłączona. Prosimy o kontakt z Obsługą Klienta.",
  msg_account_disabled: "Konto zostało zablokowane",
  msg_account_frozen: "Funkcja transakcji na koncie została zamrożona",
  msg_account_gap_amount:
    "Brak wystarczających środków na koncie. Brakuje [REPLACEVALUE1]. Prosimy o kontakt z Obsługą Klienta.",
  msg_order_processing_success: "Przetwarzanie zamówienia zakończone",
  msg_progress_title:
    "Pełna moc wydobycia, szacowany czas<span style='color: red'>&nbsp;3 sekundy&nbsp;</span>Prosimy nie opuszczać interfejsu!",
  msg_progress_note1: "Synchronizacja najnowszych informacji...",
  msg_progress_note2: "Sprawdzanie informacji o produkcie...",
  msg_progress_note3: "Dopasowywanie zamówień produktów...",
  msg_progress_note4: "Przetwarzanie najlepszego produktu...",
  msg_receive_withdrawal_transfer:
    "Środki zostaną przelane w ciągu pół godziny",
  msg_insufficient_creditbalance: "Niewystarczający kredyt",
  msg_insufficient_creditscore: "Niewystarczający wynik kredytowy",
  msg_invalid_password: "Nieprawidłowe hasło",
  msg_input_withdrawalpassword: "Proszę wprowadzić hasło do wypłat",
  msg_please_input_userid: "Proszę wprowadzić nazwę użytkownika",
  msg_please_input_pass: "Proszę wprowadzić hasło",
  msg_please_input_mobileno: "Proszę wprowadzić numer telefonu",
  msg_pass_min_length: "Hasło musi mieć co najmniej 8 znaków",
  msg_pass_format:
    "Hasło musi zawierać tylko litery i cyfry oraz mieć od 8 do 50 znaków",
  msg_pass_confirm: "Proszę ponownie wprowadzić hasło",
  msg_withpass_min_length: "Hasło do wypłat musi mieć co najmniej 8 znaków",
  msg_withpass_format:
    "Hasło do wypłat musi zawierać tylko litery i cyfry oraz mieć od 8 do 50 znaków",
  msg_please_input_invitecode: "Proszę wprowadzić kod zaproszenia",
  msg_balance_insufficient:
    "Nie można rozpocząć handlu, ponieważ saldo jest niższe niż minimalna wartość aktywacji. Prosimy o kontakt z Obsługą Klienta",
  msg_recharge: "Prosimy o kontakt z Obsługą Klienta",
  msg_bank_pass_notice:
    "Użytkowniku, prosimy nie wprowadzać hasła do konta bankowego w tym polu. Nasi pracownicy nie wymagają podawania hasła.",
  msg_mandatory_bankname: "Proszę wprowadzić nazwę banku",
  msg_mandatory_bankaccname: "Proszę wprowadzić nazwę rachunku bankowego",
  msg_mandatory_bankaccno: "Proszę wprowadzić numer rachunku bankowego",
  msg_bank_pass_notice2:
    "Uwaga: Jeśli użytkownik potrzebuje zresetować adres portfela, prosimy o kontakt z Obsługą Klienta.",
  msg_luckydraw_insufficientdrawcount: "Niewystarczająca liczba losów",
  msg_username_exist: "Nazwa użytkownika już istnieje",
  msg_mobileno_exist: "Numer telefonu komórkowego został zarejestrowany",
  msg_invalid_invitationcode: "Nieprawidłowy kod zaproszenia",
  msg_inactive_invitationcode: "Kod zaproszenia jest nieaktywny",
  msg_invitation_notallowed: "Twój polecający nie ma uprawnień do zapraszania",
  msg_mandatory_ordercompletebeforerequest:
    "Zakończ swoje zamówienia przed złożeniem nowego żądania",
};
window.pl = pl;
var jp = {
  Home: "ホーム",
  Boost: "ブースト",
  Rejected: "拒否されました",
  Completed: "完了しました",
  Pending: "保留中",
  Profile: "プロフィール",
  Record: "記録",
  Remark: "備考",
  Starting: "開始",
  Transactions: "取引",
  DepositAmount: "入金額",
  DepositHistory: "入金履歴",
  WithdrawalAmount: "出金額",
  WithdrawalHistory: "出金履歴",
  TopWithdrawal: "最高出金額",
  Withdrawal: "出金",
  Invite: "招待",
  LuckyDraw: "ラッキードロー",
  BindAccount: "アカウントを連携",
  BankName: "銀行名",
  BankAccountName: "口座名義",
  BankAccountNo: "口座番号",
  Recharge: "リチャージ",
  ProductName: "商品名",
  ProductNumber: "商品番号",
  OrderHistory: "注文履歴",
  All: "すべて",
  BindWallet: "ウォレットを連携",
  Logout: "ログアウト",
  Language: "言語",
  MandatoryWalletAddress: "*ウォレットアドレス",
  Exchange: "両替",
  Commission: "手数料",
  CurrentBalance: "現在の残高",
  ContactUs: "お問い合わせ",
  LoginNameMobileNo: "ユーザー名 / 携帯番号",
  Password: "パスワード",
  ConfirmPassword: "パスワード確認",
  WithdrawalPassword: "出金パスワード",
  ChangePassword: "パスワードを変更",
  ForgotPass: "パスワードを忘れましたか？",
  SignIn: "ログイン",
  Register: "登録",
  Username: "ユーザー名",
  Login: "ログイン",
  RegisterAgreement: "登録規約",
  MobileNo: "携帯番号",
  InvitationCode: "招待コード",
  CreditScore: "信用スコア",
  BackToLogin: "ログインに戻る",
  MembershipLevel: "会員レベル",
  TodaysCommission: "今日の手数料",
  TodaysTotalReset: "今日のトータルリセット",
  TotalCommission: "合計手数料",
  TotalAmount: "合計金額",
  LatestEvent: "最新イベント",
  AboutUs: "私たちについて",
  TNC: "利用規約",
  TeamReport: "チームレポート",
  Certificate: "証明書",
  OnlineUsers: "オンラインユーザー",
  FromLastMonth: "先月から",
  OptimizeDemand: "需要を最適化",
  OrderCompletion: "注文完了",
  OrderQuantity: "注文数量",
  Confirm: "確認",
  Cancel: "キャンセル",
  Submit: "送信",
  Profit: "利益",
  Value: "価値",
  StartNow: "今すぐ始める",
  AccountBalance: "アカウント残高",
  FreezeAmount: "処理中の金額",
  Frozen: "処理中",
  MessageList: "メッセージリスト",
  OrderSubmission: "注文の送信",
  CreateTime: "作成時間",
  OrderNumber: "注文番号",
  OrderDetails: "注文詳細",
  MyReferralCode: "私の紹介コード",
  CopyReferralCode: "紹介コードをコピー",
  success: "成功",
  msg_login_success: "ログイン成功",
  msg_logout_confirm: "アカウントをログアウトしてもよろしいですか？",
  msg_workingtime: "営業時間",
  msg_depositwithdrawal:
    "入出金については、カスタマーサービスにお問い合わせください",
  msg_clicktocontactus: "カスタマーサービスに連絡するにはクリックしてください",
  msg_accountnotexist: "アカウントまたはパスワードが無効です",
  msg_invalidpassword: "無効なパスワードです",
  msg_grab_order_period:
    "この操作は、指定された時間[START]:00 - [END]:00にのみ実行できます",
  msg_withdrawalamount_range: "出金額の範囲は[MINAMT] - [MAXAMT]です",
  msg_withdrawalamount_reservedamt: "最初の出金は予約が必要です [MINAMT]",
  msg_grab_order_disabled:
    "この操作は無効です。カスタマーサービスにお問い合わせください。",
  msg_account_disabled: "アカウントが無効になっています",
  msg_account_frozen: "アカウント取引機能が凍結されています",
  msg_account_gap_amount:
    "アカウント残高が不足しています。不足額は[REPLACEVALUE1]です。カスタマーサービスにお問い合わせください。",
  msg_order_processing_success: "注文処理が完了しました",
  msg_progress_title:
    "全力で抽出中です。推定<span style='color: red'>&nbsp;3秒&nbsp;</span>離れないでください！",
  msg_progress_note1: "最新情報を同期中...",
  msg_progress_note2: "商品情報を確認中...",
  msg_progress_note3: "商品注文を照合中...",
  msg_progress_note4: "最適な商品を処理中...",
  msg_receive_withdrawal_transfer: "出金は30分以内に処理されます",
  msg_insufficient_creditbalance: "クレジットが不足しています",
  msg_insufficient_creditscore: "信用スコアが不足しています",
  msg_invalid_password: "無効なパスワードです",
  msg_input_withdrawalpassword: "出金パスワードを入力してください",
  msg_please_input_userid: "ユーザー名を入力してください",
  msg_please_input_pass: "ログインパスワードを入力してください",
  msg_please_input_mobileno: "携帯番号を入力してください",
  msg_pass_min_length: "パスワードは8文字以上でなければなりません",
  msg_pass_format:
    "パスワードは英数字のみで、8～50文字の長さにする必要があります",
  msg_pass_confirm: "ログインパスワードを再入力してください",
  msg_withpass_min_length: "出金パスワードは8文字以上でなければなりません",
  msg_withpass_format:
    "出金パスワードは英数字のみで、8～50文字の長さにする必要があります",
  msg_please_input_invitecode: "招待コードを入力してください",
  msg_balance_insufficient:
    "最低アクティベーション値よりも残高が低いため、取引を開始できません。詳細はカスタマーサービスにお問い合わせください",
  msg_recharge: "詳細はカスタマーサービスにお問い合わせください",
  msg_bank_pass_notice:
    "ユーザー様へ：この欄に自分の銀行口座パスワードを入力しないでください。当社スタッフは口座パスワードの提供を要求することはありません。",
  msg_mandatory_bankname: "銀行名を入力してください",
  msg_mandatory_bankaccname: "口座名義を入力してください",
  msg_mandatory_bankaccno: "口座番号を入力してください",
  msg_bank_pass_notice2:
    "注意：ウォレットアドレスのリセットが必要な場合は、カスタマーサービスにお問い合わせください。",
  msg_luckydraw_insufficientdrawcount: "抽選回数が不足しています",
  msg_username_exist: "ユーザー名が重複しています",
  msg_mobileno_exist: "携帯電話番号が登録されています",
  msg_invalid_invitationcode: "無効な招待コードです",
  msg_inactive_invitationcode: "招待コードが無効です",
  msg_invitation_notallowed: "紹介者には招待権限がありません",
  msg_mandatory_ordercompletebeforerequest:
    "新しいリクエストを送信する前に注文を完了してください",
};
window.jp = jp;
const my = {
  DataSubmission: "Penyerahan Data",
  FetchingData: "Mengambil Data",
  Home: "Laman Utama",
  Boost: "Tingkatkan",
  Rejected: "Ditolak",
  Completed: "Selesai",
  Pending: "Tertunda",
  Profile: "Profil",
  Record: "Rekod",
  Remark: "Catatan",
  Starting: "Memulakan",
  Transactions: "Transaksi",
  DepositAmount: "Jumlah Deposit",
  DepositHistory: "Sejarah Deposit",
  WithdrawalAmount: "Jumlah Pengeluaran",
  WithdrawalHistory: "Sejarah Pengeluaran",
  TopWithdrawal: "Pengeluaran Teratas",
  Withdrawal: "Pengeluaran",
  Invite: "Jemput",
  LuckyDraw: "Cabutan Bertuah",
  BindAccount: "Pautkan Akaun",
  BankName: "Nama Bank",
  BankAccountName: "Nama Akaun Bank",
  BankAccountNo: "No Akaun Bank",
  Recharge: "Tambah Nilai",
  ProductName: "Nama Produk",
  ProductNumber: "Nombor Produk",
  OrderHistory: "Sejarah Pesanan",
  All: "Semua",
  BindWallet: "Pautkan Dompet",
  Logout: "Log Keluar",
  Language: "Bahasa",
  MandatoryWalletAddress: "*Alamat Dompet",
  Exchange: "Pertukaran",
  Commission: "Komisen",
  CurrentBalance: "Baki Semasa",
  ContactUs: "Hubungi Kami",
  LoginNameMobileNo: "Nama Pengguna / No Telefon",
  Password: "Kata Laluan",
  ConfirmPassword: "Sahkan Kata Laluan",
  WithdrawalPassword: "Kata Laluan Pengeluaran",
  ChangePassword: "Tukar Kata Laluan",
  ForgotPass: "Lupa Kata Laluan?",
  SignIn: "Log Masuk",
  Register: "Daftar",
  Username: "Nama Pengguna",
  Login: "Log Masuk",
  RegisterAgreement: "Perjanjian Pendaftaran",
  MobileNo: "No Telefon",
  InvitationCode: "Kod Jemputan",
  CreditScore: "Skor Kredit",
  BackToLogin: "Kembali ke Log Masuk",
  MembershipLevel: "Tahap Keahlian",
  TodaysCommission: "Komisen Hari Ini",
  TotalAmount: "Jumlah Keseluruhan",
  LatestEvent: "Acara Terkini",
  AboutUs: "Tentang Kami",
  TNC: "Terma & Syarat",
  TeamReport: "Laporan Pasukan",
  Certificate: "Sijil",
  OnlineUsers: "Pengguna Dalam Talian",
  FromLastMonth: "Dari Bulan Lepas",
  OptimizeDemand: "Optimakan Permintaan",
  OrderCompletion: "Penyempurnaan Pesanan",
  OrderQuantity: "Kuantiti Pesanan",
  Confirm: "Sahkan",
  Cancel: "Batal",
  Submit: "Hantar",
  Profit: "Keuntungan",
  Value: "Nilai",
  StartNow: "Mula Sekarang",
  AccountBalance: "Baki Akaun",
  FreezeAmount: "Jumlah Dalam Pemprosesan",
  Frozen: "Sedang Diproses",
  MessageList: "Senarai Mesej",
  OrderSubmission: "Penyerahan Pesanan",
  CreateTime: "Masa Ciptaan",
  OrderNumber: "Nombor Pesanan",
  OrderDetails: "Butiran Pesanan",
  MyReferralCode: "Kod Rujukan Saya",
  CopyReferralCode: "Salin Kod Rujukan",
  success: "Berjaya",
  SignInBonus: "Bonus Log Masuk",
  msg_login_success: "Log Masuk Berjaya",
  msg_logout_confirm: "Adakah anda pasti mahu log keluar akaun?",
  msg_workingtime: "Masa bekerja",
  msg_depositwithdrawal:
    "Untuk deposit dan pengeluaran, sila hubungi Khidmat Pelanggan kami",
  msg_clicktocontactus: "Klik Untuk Menghubungi Khidmat Pelanggan",
  msg_accountnotexist: "Akaun atau kata laluan tidak sah",
  msg_invalidpassword: "Kata laluan tidak sah",
  msg_grab_order_period:
    "Operasi ini hanya boleh dilakukan dalam tempoh masa tertentu [START]:00 - [END]:00",
  msg_withdrawalamount_range: "Had pengeluaran ialah [MINAMT] - [MAXAMT]",
  msg_withdrawalamount_reservedamt:
    "Pengeluaran pertama mesti menyimpan [MINAMT]",
  msg_grab_order_disabled:
    "Operasi ini dinyahdayakan. Sila hubungi khidmat pelanggan.",
  msg_account_disabled: "Akaun telah dinyahdayakan",
  msg_account_frozen: "Fungsi transaksi akaun telah dibekukan",
  msg_account_gap_amount:
    "Baki akaun anda tidak mencukupi, terdapat kekurangan sebanyak [REPLACEVALUE1]. Sila hubungi khidmat pelanggan.",
  msg_order_processing_success: "Pemprosesan pesanan selesai",
  msg_progress_title:
    "Mengekstrak pada kapasiti penuh, Anggaran memerlukan<span style='color: red'> &nbsp;3s&nbsp;</span>Sila jangan tinggalkan antara muka!",
  msg_progress_note1: "Menyelaraskan maklumat terkini...",
  msg_progress_note2: "Memeriksa maklumat produk...",
  msg_progress_note3: "Memadankan pesanan produk...",
  msg_progress_note4: "Memproses produk terbaik...",
  msg_receive_withdrawal_transfer:
    "Anda akan menerima pengeluaran anda dalam masa setengah jam",
  msg_insufficient_creditbalance: "Baki kredit tidak mencukupi",
  msg_insufficient_creditscore: "Skor kredit tidak mencukupi",
  msg_invalid_password: "Kata laluan tidak sah",
  msg_input_withdrawalpassword: "Sila masukkan kata laluan pengeluaran",
  msg_please_input_userid: "Sila masukkan nama pengguna anda",
  msg_please_input_pass: "Sila masukkan kata laluan log masuk",
  msg_please_input_mobileno: "Sila masukkan nombor telefon anda",
  msg_pass_min_length: "Panjang kata laluan mesti sekurang-kurangnya 8",
  msg_pass_format:
    "Kata laluan mesti mengandungi huruf dan nombor sahaja dengan panjang 8 hingga 50",
  msg_pass_confirm: "Sila masukkan semula kata laluan log masuk",
  msg_withpass_min_length:
    "Panjang kata laluan pengeluaran mesti sekurang-kurangnya 8",
  msg_withpass_format:
    "Kata laluan pengeluaran mesti mengandungi huruf dan nombor sahaja dengan panjang 8 hingga 50",
  msg_please_input_invitecode: "Sila masukkan kod jemputan",
  msg_balance_insufficient:
    "Tidak dapat memulakan perdagangan kerana baki lebih rendah daripada nilai pengaktifan minimum. Sila hubungi khidmat pelanggan untuk bantuan lanjut",
  msg_recharge: "Sila hubungi khidmat pelanggan untuk bantuan lanjut",
  msg_bank_pass_notice:
    "Pengguna yang dihormati, Sila jangan masukkan kata laluan akaun bank anda dalam kotak ini. Kakitangan kami tidak akan meminta anda memberikan kata laluan akaun bank anda.",
  msg_mandatory_bankname: "Sila masukkan nama bank",
  msg_mandatory_bankaccname: "Sila masukkan nama akaun bank",
  msg_mandatory_bankaccno: "Sila masukkan nombor akaun bank",
  msg_bank_pass_notice2:
    "Nota: Jika pengguna perlu menetapkan semula alamat dompet, sila hubungi khidmat pelanggan kami.",
  msg_luckydraw_insufficientdrawcount: "Bilangan cabutan tidak mencukupi",
  msg_username_exist: "Nama pengguna telah digunakan",
  msg_mobileno_exist: "Nombor telefon telah didaftarkan",
  msg_invalid_invitationcode: "Kod jemputan tidak sah",
  msg_inactive_invitationcode: "Kod jemputan tidak aktif",
  msg_invitation_notallowed:
    "Penaung anda tidak mempunyai kebenaran untuk menjemput",
  msg_mandatory_ordercompletebeforerequest:
    "Selesaikan pesanan anda sebelum menghantar permintaan baru",
  msg_deposit_notice: "Sila sahkan rangkaian deposit dan alamat kami",
  msg_mandatory_bank_receipt: "Resit Bank Diperlukan",
  msg_topup_required: "Sila tambah nilai untuk ganjaran",
};
window.my = my;
const kz = {
  DataSubmission: "Деректерді жіберу",
  FetchingData: "Деректерді алу",
  Home: "Басты бет",
  Boost: "Күшейту",
  Rejected: "Қабылданбады",
  Completed: "Аяқталды",
  Pending: "Күтілуде",
  Profile: "Профиль",
  Record: "Жазба",
  Remark: "Ескерту",
  Starting: "Бастау",
  Transactions: "Транзакциялар",
  DepositAmount: "Депозит сомасы",
  DepositHistory: "Депозит тарихы",
  WithdrawalAmount: "Шығару сомасы",
  WithdrawalHistory: "Шығару тарихы",
  TopWithdrawal: "Үздік шығару",
  Withdrawal: "Қаражат шығару",
  Invite: "Шақыру",
  LuckyDraw: "Лотерея",
  BindAccount: "Есептік жазбаны байланыстыру",
  BankName: "Банк атауы",
  BankAccountName: "Банк шотының атауы",
  BankAccountNo: "Банк шотының нөмірі",
  Recharge: "Қайта толықтыру",
  ProductName: "Өнім атауы",
  ProductNumber: "Өнім нөмірі",
  OrderHistory: "Тапсырыс тарихы",
  All: "Барлығы",
  BindWallet: "Әмиянды байланыстыру",
  Logout: "Шығу",
  Language: "Тіл",
  MandatoryWalletAddress: "*Әмиян мекенжайы",
  Exchange: "Айырбастау",
  Commission: "Комиссия",
  CurrentBalance: "Ағымдағы баланс",
  ContactUs: "Бізбен байланысу",
  LoginNameMobileNo: "Пайдаланушы аты / Телефон нөмірі",
  Password: "Құпия сөз",
  ConfirmPassword: "Құпия сөзді растау",
  WithdrawalPassword: "Шығару құпия сөзі",
  ChangePassword: "Құпия сөзді өзгерту",
  ForgotPass: "Құпия сөзіңізді ұмыттыңыз ба?",
  SignIn: "Кіру",
  Register: "Тіркелу",
  Username: "Пайдаланушы аты",
  Login: "Кіру",
  RegisterAgreement: "Тіркеу келісімі",
  MobileNo: "Телефон нөмірі",
  InvitationCode: "Шақыру коды",
  CreditScore: "Несие рейтингі",
  BackToLogin: "Кіру бетіне оралу",
  MembershipLevel: "Мүшелік деңгейі",
  TodaysCommission: "Бүгінгі комиссия",
  TotalAmount: "Жалпы сома",
  LatestEvent: "Соңғы оқиға",
  AboutUs: "Біз туралы",
  TNC: "Шарттар мен талаптар",
  TeamReport: "Команда есебі",
  Certificate: "Куәлік",
  OnlineUsers: "Желіде қолданушылар",
  FromLastMonth: "Өткен айдан бастап",
  OptimizeDemand: "Сұранысты оңтайландыру",
  OrderCompletion: "Тапсырысты аяқтау",
  OrderQuantity: "Тапсырыс саны",
  Confirm: "Растау",
  Cancel: "Бас тарту",
  Submit: "Жіберу",
  Profit: "Пайда",
  Value: "Құндылық",
  StartNow: "Қазір бастау",
  AccountBalance: "Шот балансы",
  FreezeAmount: "Өңделіп жатқан сома",
  Frozen: "Өңделуде",
  MessageList: "Хабарламалар тізімі",
  OrderSubmission: "Тапсырысты жіберу",
  CreateTime: "Құру уақыты",
  OrderNumber: "Тапсырыс нөмірі",
  OrderDetails: "Тапсырыс мәліметтері",
  MyReferralCode: "Менің реферальды кодым",
  CopyReferralCode: "Реферальды кодты көшіру",
  success: "Сәтті",
  SignInBonus: "Кіру бонусы",
  msg_login_success: "Кіру сәтті аяқталды",
  msg_logout_confirm: "Есептік жазбадан шығуды қалайсыз ба?",
  msg_workingtime: "Жұмыс уақыты",
  msg_depositwithdrawal:
    "Депозит пен шығару үшін біздің клиенттерге қызмет көрсету орталығына хабарласыңыз",
  msg_clicktocontactus:
    "Клиенттерге қызмет көрсету орталығына хабарласу үшін басыңыз",
  msg_accountnotexist: "Қате пайдаланушы аты немесе құпия сөз",
  msg_invalidpassword: "Қате құпия сөз",
  msg_grab_order_period:
    "Бұл операция тек белгіленген уақытта орындалады [START]:00 - [END]:00",
  msg_withdrawalamount_range: "Шығаруға болатын сома: [MINAMT] - [MAXAMT]",
  msg_withdrawalamount_reservedamt:
    "Бірінші шығару үшін [MINAMT] резервте болуы керек",
  msg_grab_order_disabled:
    "Бұл операция өшірілген. Қолдау қызметіне хабарласыңыз.",
  msg_account_disabled: "Есептік жазба бұғатталған",
  msg_account_frozen: "Шоттағы транзакциялар бұғатталған",
  msg_account_gap_amount:
    "Шот балансы жеткіліксіз, жетіспейтін сома: [REPLACEVALUE1]. Қолдау қызметіне хабарласыңыз.",
  msg_order_processing_success: "Тапсырыс сәтті өңделді",
  msg_receive_withdrawal_transfer: "Шығарылған қаражат 30 минут ішінде түседі",
  msg_insufficient_creditbalance: "Жеткіліксіз кредит",
  msg_insufficient_creditscore: "Жеткіліксіз несие рейтингі",
  msg_invalid_password: "Қате құпия сөз",
  msg_input_withdrawalpassword: "Шығару құпия сөзін енгізіңіз",
  msg_please_input_userid: "Пайдаланушы атын енгізіңіз",
  msg_please_input_pass: "Кіру құпия сөзін енгізіңіз",
  msg_please_input_mobileno: "Телефон нөміріңізді енгізіңіз",
  msg_pass_min_length: "Құпия сөз кемінде 8 таңбадан тұруы керек",
  msg_pass_format:
    "Құпия сөз тек әріптер мен сандардан тұруы керек (8-ден 50 таңбаға дейін)",
  msg_please_input_invitecode: "Шақыру кодын енгізіңіз",
  msg_balance_insufficient:
    "Төмен баланстан сауда бастау мүмкін емес. Қолдау қызметіне хабарласыңыз.",
  msg_recharge:
    "Қосымша көмек алу үшін клиенттерге қызмет көрсету орталығына хабарласыңыз",
  msg_bank_pass_notice:
    "Құрметті пайдаланушы, банк шотыңыздың құпия сөзін енгізбеңіз. Қызметкерлеріміз сізден мұндай ақпаратты сұрамайды.",
  msg_mandatory_bankname: "Банк атауын енгізіңіз",
  msg_mandatory_bankaccname: "Банк шотының атын енгізіңіз",
  msg_mandatory_bankaccno: "Банк шотының нөмірін енгізіңіз",
  msg_bank_pass_notice2:
    "Ескерту: Әмиян мекенжайын қайта орнату қажет болса, қолдау қызметіне хабарласыңыз.",
  msg_luckydraw_insufficientdrawcount:
    "Лотереяға қатысу мүмкіндігі жеткіліксіз",
  msg_username_exist: "Бұл пайдаланушы аты бұрыннан тіркелген",
  msg_mobileno_exist: "Бұл телефон нөмірі бұрын тіркелген",
  msg_invalid_invitationcode: "Жарамсыз шақыру коды",
  msg_inactive_invitationcode: "Шақыру коды белсенді емес",
  msg_mandatory_ordercompletebeforerequest:
    "Жаңа сұраныс жібермес бұрын тапсырыстарды аяқтаңыз",
  msg_topup_required: "Сыйақы алу үшін шотыңызды толтырыңыз",
};
window.kz = kz;
window.lang = (function () {
  function lang(defaultLang) {
    this.allDictionaries = {
      en: en,
      es: es,
      sa: sa,
      ir: ir,
      ru: ru,
      ko: ko,
      fr: fr,
      tr: tr,
      pt: pt,
      pl: pl,
      jp: jp,
      my: my,
      kz: kz,
    };
    this.dictionary = en;
    this.currentLang = "en";
    this.supportedLang = Object.keys(this.allDictionaries);
    this.singleLangCode = "en";
    this.setLang(defaultLang);
  }
  lang.prototype.setLang = function (newLanguage) {
    var self = this;
    if (newLanguage) {
      var preLangCode = self.currentLang;
      helperObj.setCookie("lang", newLanguage, "/");
      newLanguage = newLanguage.toLocaleLowerCase();
      if (this.supportedLang.indexOf(newLanguage) >= 0) {
        self.currentLang = newLanguage;
        self.singleLangCode = newLanguage.substring(
          self.currentLang.indexOf("-") + 1,
          newLanguage.length
        );
      } else {
        var errMsg = "Lang " + newLanguage + " is not supported.";
        self.throwError(errMsg);
      }
      if (newLanguage.indexOf("-") > 0) {
        newLanguage = newLanguage.substring(
          newLanguage.indexOf("-") + 1,
          newLanguage.length
        );
      }
      var bodyEle = document.getElementsByTagName("body")[0];
      bodyEle.classList.remove(preLangCode);
      bodyEle.classList.add(newLanguage);
    }
    self.dictionary = self.allDictionaries[newLanguage];
  };
  lang.prototype.getWord = function (word, replaceValue1) {
    if (replaceValue1 === void 0) {
      replaceValue1 = "";
    }
    var self = this;
    var selectedWord = null;
    if (word) {
      if (_ && _.get) {
        var translatedWord = _.get(self.dictionary, word);
        if (!translatedWord && self.currentLang != "en") {
          translatedWord = _.get(self.allDictionaries.en, word);
        }
        if (
          translatedWord &&
          typeof translatedWord === "string" &&
          translatedWord.includes("[REPLACEVALUE1]")
        ) {
          translatedWord = translatedWord.replace(
            "[REPLACEVALUE1]",
            replaceValue1
          );
        }
        return translatedWord ? translatedWord : word;
      }
      if (self.dictionary[word]) {
        selectedWord = self.dictionary[word];
      } else {
        var wordKeys = Object.getOwnPropertyNames(en);
        var foundWords = wordKeys.filter(function (indexWord) {
          return indexWord.toUpperCase() === word.toUpperCase();
        });
        if (foundWords && foundWords.length) {
          selectedWord = self.dictionary[foundWords[0]];
        }
        if (!selectedWord && self.currentLang != "en") {
          selectedWord = en[word];
        }
        if (!selectedWord) {
          selectedWord = word;
        }
        var errMsg =
          "Word " +
          word +
          " is not available in " +
          self.currentLang +
          ". Please update the lang dictionary.";
        self.throwError(errMsg);
      }
    }
    return selectedWord;
  };
  lang.prototype.translateWord = function () {
    var self = this;
    var $words = $("[data-lang]");

    for (var _b = 0, _c = $words.toArray(); _b < _c.length; _b++) {
      var word = _c[_b];
      var $word = $(word);
      var translatedWord = self.getWord(
        word.attributes.getNamedItem("data-lang").value
      );

      if (word.tagName === "INPUT") {
        $word.attr("placeholder", translatedWord);
      } else {
        $word.text(translatedWord);
      }
    }
  };
  lang.prototype.translateWordByElement = function ($element) {
    var self = this;
    var $words = $element.find("[data-lang]");
    for (var _b = 0, _c = $words.toArray(); _b < _c.length; _b++) {
      var word = _c[_b];
      var $word = $(word);
      var translatedWord = self.getWord(
        word.attributes.getNamedItem("data-lang").value
      );
      if (word.tagName === "INPUT") {
        $word.attr("placeholder", translatedWord);
      } else {
        $word.text(translatedWord);
      }
    }
  };
  lang.prototype.throwError = function () {
    var errMsg = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      errMsg[_i] = arguments[_i];
    }
    console.log("Lang.js validation error log", errMsg);
  };
  return lang;
})();
